/**
 * AgeMate Custom Cart Drawer v8
 * - Welcome kit image fallback, sessionStorage cart cache, optimistic add.
 * v8.2: ROOT prefix on all API calls; market-aware fallback handle.
 * v8.3 (region sync): market-specific cache, region-swap on market change,
 *      Welcome Kit self-heal at checkout, loading state, single-flight lock.
 */

/* LIVE BUILD — generated by build-live-cart.py from the dev file.
   Every variant, kit, shaker, booster and selling-plan id below was swapped
   from dev to live using a map DERIVED from the two CONFIG blocks, not typed.
   Do not hand-edit ids here: change dev, re-run the script. The dev build is
   dev-theme/assets/cart-drawer-custom.js and must never be uploaded to live. */

(function () {
  'use strict';

  // Single-init guard: a second copy of this script on the page would stack another
  // window.fetch override and duplicate every listener, recreating the cart races. Run once.
  if (window.__AM_CART_INIT__) return;
  window.__AM_CART_INIT__ = true;

const CONFIG = {
  singleSub: [44372896579824, 49560130420976, 45885826662640],   // AU, EX, NR
  doubleSub: [44372896612592, 49560130453744, 45885826695408],   // AU, EX, NR
  oneTime:   [44372896547056, 49560130486512, 45885826728176],   // AU, EX, NR
  kits: {
    auEx: { single: 47917130449136, double: 47917130350832 },
    ex:   { single: 50308684447984, double: 50308734025968 },
    nr:   { single: 47917130186992, double: 47917130088688 }
  },
  shaker: 44377485803760,
  allGiftIds: [47917130449136, 47917130350832, 50308684447984, 50308734025968, 47917130186992, 47917130088688, 44377485803760],
  /* FOUR TUBS PER ORDER, however the shopper gets there: 4 x Single, 2 x Double,
     or any mix. maxTotalSub is the real ceiling and it counts a Double as two.
     The per-line caps below exist only so one line cannot exceed that on its
     own - they must never be LOWER than maxTotalSub allows, or the cart and the
     PDP end up quoting different numbers (singles used to stop at 3 while the
     PDP said 4). Either route earns exactly one double Welcome Kit; see
     computeDesiredGifts, which keys off total servings, not line count. */
  maxSingleSub: 4,
  maxDoubleSub: 2,
  maxTotalSub: 4,
  otpToSingleSub: {
    44372896547056: 44372896579824,   // AU  OTP -> single sub
    49560130486512: 49560130420976,   // EX  OTP -> single sub
    45885826728176: 45885826662640    // NR  OTP -> single sub
  },
variantToSellingPlan: {
    44372896579824: 4999184624, 44372896612592: 4999184624,   // AU
    49560130420976: 7546732784, 49560130453744: 7546732784,   // EX
    45885826662640: 5302518000, 45885826695408: 5302518000,   // NR
    50304050823408: 8317305072,   // Sleep booster  -> add-on plan
    47589031969008: 8317272304,   // Skin & Joint   -> add-on plan
    47589041996016: 8317370608,   // Hormone        -> add-on plan
    47566495777008: 8317337840    // Metabolic      -> add-on plan
  },
  auFreeShippingCents: 10000,
  fallbackImages: {
        singleKit: 'https://cdn.shopify.com/s/files/1/0651/0346/2640/files/Welcome_Kit_2026.webp?v=1792980318',
    doubleKit: 'https://cdn.shopify.com/s/files/1/0651/0346/2640/files/AgeMate-Welcome-Pack-Double-Container-Bottle-BlueBG.jpg?v=1700008306',
    shaker: 'https://cdn.shopify.com/s/files/1/0651/0346/2640/files/AgeMate-Drink-Bottle-BlueBG.jpg?v=1700007749'
  },
boosters: [
    { key: 'sleep',     handle: 'sleep-support',        title: 'Sleep Support',          sub: 50304050823408, otp: 50304050856176, addonPlan: 8317305072, serving: '30 serves', tablets: 30 },
    { key: 'skin',      handle: 'collagen-support',     title: 'Collagen Support',       sub: 47589031969008, otp: 47589032001776, addonPlan: 8317272304, serving: '30 serves', tablets: 60 },
    { key: 'hormone',   handle: 'hormone-support',      title: "Women Hormone Support", sub: 47589041996016, otp: 47589042028784, addonPlan: 8317370608, serving: '30 serves', tablets: 60 },
    { key: 'metabolic', handle: 'metabolic-support',    title: 'Metabolic Support',      sub: 47566495777008, otp: 47566495809776, addonPlan: 8317337840, serving: '30 serves', tablets: 60 }
  ]
};
const BOOSTER_SUB_IDS = CONFIG.boosters.map(b => b.sub);
  const BOOSTER_OTP_IDS = CONFIG.boosters.map(b => b.otp);
  const BOOSTER_BY_VARIANT = {};
  CONFIG.boosters.forEach(b => { BOOSTER_BY_VARIANT[b.sub] = b; BOOSTER_BY_VARIANT[b.otp] = b; });

  // sessionStorage cache key — market-specific so one market's cart can't render in another
  const CACHE_KEY = 'am_cart_v8_' + ((window.Shopify && (Shopify.country || (Shopify.currency && Shopify.currency.active))) || 'x');

const productPriceCache = {};
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  // On the /cart page, main-cart.liquid owns cart reconciliation and its own fetch
  // interceptor reloads the page on any /cart write. The drawer must therefore skip
  // its AUTOMATIC load-time writes (region-sync, orphan-DLB, gift auto-fix) there,
  // or the two fight (stranded carts / reload loop). Explicit user writes are fine.
  const IS_CART_PAGE = window.location.pathname.replace(/\/+$/,'').endsWith('/cart');
  const CUSTOMER_HAS_KIT = !!(window.AM_CART_SETTINGS && window.AM_CART_SETTINGS.customerHasHadKit);

  // Theme-editor toggles (set by cart-drawer.liquid). All default ON.
  const CART_SETTINGS = (window.AM_CART_SETTINGS && typeof window.AM_CART_SETTINGS === 'object') ? window.AM_CART_SETTINGS : {};
  const SHOW_UPSELL   = CART_SETTINGS.showUpsell !== false;
  const SHOW_BOOSTERS = CART_SETTINGS.showBoosters !== false;
  const SHOW_SHIPBAR  = CART_SETTINGS.showShippingBar !== false;

  let cart = null;
  let isUpdating = false;
  let isOpen = false;
  let internalAddDepth = 0;   // was addingFromUs (boolean). Counter avoids a flip race between overlapping internal adds.
  let drawerReadyResolve = null;

  const $ = (sel) => document.querySelector(sel);
  const drawer = $('#am-cart-drawer');
  const overlay = $('#am-cart-overlay');
  const closeBtn = $('#am-cart-close');
  const continueBtn = $('#am-cart-continue');
  const body = document.body;

  const emptyEl = $('#am-cart-empty');
  const itemsEl = $('#am-cart-items');
  const subSection = $('#am-cart-sub-section');
  const otpSection = $('#am-cart-otp-section');
  const giftsSection = $('#am-cart-gifts-section');
  const giftsDivider = $('#am-cart-gifts-divider');
  const subItems = $('#am-cart-sub-items');
  const otpItems = $('#am-cart-otp-items');
  const giftItems = $('#am-cart-gift-items');
  const clearWrap = $('#am-cart-clear-wrap');
  const clearBtn = $('#am-cart-clear');
  const footerEl = $('#am-cart-footer');
  const subtotalEl = $('#am-cart-subtotal');
  const checkoutForm = $('#am-cart-checkout-form');
  const checkoutBtn = checkoutForm ? checkoutForm.querySelector('button, [type="submit"], a') : null;
  const promoToggle = $('#am-cart-promo-toggle');
  const promoForm = $('#am-cart-promo-form');
  const promoInput = $('#am-cart-promo-input');
  const promoApply = $('#am-cart-promo-apply');
  const promoMsg = $('#am-cart-promo-msg');
const promoDefault = $('#am-cart-promo-default');
  const promoApplied = $('#am-cart-promo-applied');
  const promoPillCode = $('#am-cart-promo-pill-code');
  const promoPillAmount = $('#am-cart-promo-pill-amount');
  const discountDefault = $('#am-cart-discount-default');
  const discountApplied = $('#am-cart-discount-applied');
  const discountCodeEl = $('#am-cart-discount-code');
  const discountAmountEl = $('#am-cart-discount-amount');
  const shippingBar = $('#am-cart-shipping-bar');
  const shippingMsg = $('#am-cart-shipping-msg');
  const shippingFill = $('#am-cart-shipping-fill');
  const upsellSub = $('#am-cart-upsell-sub');
  const upsellSubMsg = $('#am-cart-upsell-sub-msg');
  const upsellSubBtn = $('#am-cart-upsell-sub-btn');

  /* =========================================
     HELPERS
     ========================================= */

  /* PRODUCT TITLES ARE STAFF-EDITABLE AND GO STRAIGHT INTO innerHTML.
     A title containing a quote and an onerror handler would break out of the
     alt="" attribute and run on every drawer render, on every page. Escape
     anything that comes from /cart.js before it is interpolated. */
  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function isSingleSub(v) { return CONFIG.singleSub.includes(v); }
  function isDoubleSub(v) { return CONFIG.doubleSub.includes(v); }
/* TWO DIFFERENT QUESTIONS, AND CONFLATING THEM LET A BOOSTER CHECK OUT ALONE.
     isDlbOneTime  "is this a one-time DAILY LONGEVITY BLEND?"  - use for every
                   "does the cart contain a Blend?" guard. A booster must never
                   satisfy one of those: boosters are add-ons only.
     isOneTime     "is this a one-time LINE?" - use for sectioning, sorting and
                   display, where a booster one-time genuinely does belong in
                   the One-Time group. */
  function isDlbOneTime(v) { return CONFIG.oneTime.includes(v); }
  function isOneTime(v) { return isDlbOneTime(v) || isBoosterOtp(v); }
  function isSubscription(v) { return isSingleSub(v) || isDoubleSub(v) || isBoosterSub(v); }
  function isGift(v) { return CONFIG.allGiftIds.includes(v); }
  function isProduct(v) { return isSingleSub(v) || isDoubleSub(v) || isOneTime(v) || isBooster(v); }
  function isWelcomeKit(v) {
    return v === CONFIG.kits.auEx.single || v === CONFIG.kits.auEx.double ||
           v === CONFIG.kits.ex.single   || v === CONFIG.kits.ex.double ||
           v === CONFIG.kits.nr.single   || v === CONFIG.kits.nr.double;
  }
  function isBoosterSub(v) { return BOOSTER_SUB_IDS.includes(v); }
  function isBoosterOtp(v) { return BOOSTER_OTP_IDS.includes(v); }
  function isBooster(v) { return isBoosterSub(v) || isBoosterOtp(v); }
  // The parent DLB dictates the mode. Returns 'sub' | 'otp' | null.
  function cartDlbMode() {
    if (!cart || !cart.items) return null;
    if (cart.items.some(i => isSingleSub(i.variant_id) || isDoubleSub(i.variant_id))) return 'sub';
    if (cart.items.some(i => isDlbOneTime(i.variant_id))) return 'otp';
    return null;
  }

  function cartHasDlb() {
    return cartDlbMode() !== null;
  }

  function getMarketForVariant(vid) {
    if (CONFIG.singleSub[2] === vid || CONFIG.doubleSub[2] === vid || CONFIG.oneTime[2] === vid) return 'nr';
    if (CONFIG.singleSub[1] === vid || CONFIG.doubleSub[1] === vid || CONFIG.oneTime[1] === vid) return 'ex';
    return 'auEx';
  }

function defaultHandleForVariant(variantId) {
    if (BOOSTER_BY_VARIANT[variantId]) return BOOSTER_BY_VARIANT[variantId].handle;
    const m = getMarketForVariant(variantId);
    if (m === 'nr') return 'daily-longevity-blend-nr';
    if (m === 'ex') return 'daily-longevity-blend-ex';
    return 'daily-longevity-blend';
  }

  function isAuMarket() {
    if (window.Shopify?.country === 'AU') return true;
    if (window.Shopify?.currency?.active === 'AUD') return true;
    return false;
  }

  function detectMarket(items) {
    let sawEx = false;
    for (const item of items) {
      const m = getMarketForVariant(item.variant_id);
      if (m === 'nr') return 'nr';
      if (m === 'ex') sawEx = true;
    }
    return sawEx ? 'ex' : 'auEx';
  }

  // 0 = AU / blend, 1 = EX (NZ/SG), 2 = NR (US/GB). -1 = unknown (skip).
  function currentMarketIndex() {
    const c   = (window.Shopify && Shopify.country) || '';
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    if (!c && !cur) return -1;
    if (c === 'US' || c === 'GB' || cur === 'USD' || cur === 'GBP') return 2;
    if (c === 'NZ' || c === 'SG' || cur === 'NZD' || cur === 'SGD') return 1;
    return 0;
  }

  function roleArrayFor(variantId) {
    if (CONFIG.singleSub.includes(variantId)) return CONFIG.singleSub;
    if (CONFIG.doubleSub.includes(variantId)) return CONFIG.doubleSub;
    if (CONFIG.oneTime.includes(variantId))   return CONFIG.oneTime;
    return null; // gift / booster / other
  }

  // ---- REGION SYNC ----------------------------------------------------------
  // Single-flight via a shared promise: only one market-sync runs at a time,
  // and any caller that arrives mid-sync gets the SAME in-flight result — so the
  // drawer never renders a half-swapped cart (blank / qty-2 / wrong price).
  let regionSyncing = false;
  let regionSyncPromise = null;

  // Returns a promise for the corrected cart, or null if nothing to do.
  // Not async at the top level on purpose — callers still `await` it.
  function syncCartToMarket(cartData) {
    /* SWITCHED OFF (audit 23 Oct 2026). Maddie decided on 28 Sep not to ship
       cart region sync to live: changing country rewrote the cart, left AU
       boosters in a non-AU cart, and a failed swap removed the Blend and left
       only the free kit. Every caller already handles null ("nothing to do"),
       so the cart is left exactly as the customer built it, as on the old
       live theme. Delete this line to turn it back on. */
    return null;
    if (regionSyncPromise) return regionSyncPromise;   // one already running -> reuse it
    if (isUpdating) return null;
    if (!cartData || !cartData.items) return null;
    const idx = currentMarketIndex();
    if (idx < 0) return null;

    const swaps = [];
    const removes = [];

    for (const item of cartData.items) {
      if (isGift(item.variant_id) || isBooster(item.variant_id)) continue;
      const arr = roleArrayFor(item.variant_id);
      if (!arr) continue;
      if (arr.indexOf(item.variant_id) === idx) continue;   // already correct market
      const target = arr[idx];
      if (target) {
        swaps.push({ key: item.key, newVid: target, qty: item.quantity,
                     plan: CONFIG.variantToSellingPlan[target] || null });
      } else {
        removes.push(item.key); // wipe fallback
      }
    }

    if (!swaps.length && !removes.length) return null; // nothing to do (common case)

    regionSyncing = true;
    if (isOpen) showDrawerLoading('Updating your cart…');   // neutral loader while we swap

    regionSyncPromise = (async () => {
      try {
        const updates = {};
        swaps.forEach(s => { updates[s.key] = 0; });
        removes.forEach(k => { updates[k] = 0; });
        await updateCartItems(updates);

        if (swaps.length) {
          const toAdd = swaps.map(s => {
            const line = { id: s.newVid, quantity: s.qty };
            if (s.plan) line.selling_plan = s.plan;
            return line;
          });
          await addToCartApi(toAdd);
        }

        const fresh = await fetchCart();
        const giftFixed = await syncGifts(fresh);   // re-align Welcome Kit to new market
        return giftFixed || fresh;
      } finally {
        regionSyncing = false;
        regionSyncPromise = null;
      }
    })();

    return regionSyncPromise;
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    if (window.Shopify?.currency?.active) {
      const code = window.Shopify.currency.active;
      const symbol = { AUD: '$', NZD: '$', SGD: '$', GBP: '£', USD: '$' }[code] || '$';
      return `${symbol}${amount} ${code}`;
    }
    return `$${amount}`;
  }
  /* Same symbol as formatMoney, without the currency code - for the small
     struck-through and saving figures, where "$217.00 AUD $177.00 AUD" would
     be noise. The real subtotal keeps formatMoney's code.
     No ".00" on whole amounts - "Saving $20", not "Saving $20.00" (Maddie,
     14 Oct 2026). Real cents still show ("$19.50"). */
  function formatMoneyShort(cents) {
    const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    const code = window.Shopify?.currency?.active;
    const symbol = { AUD: '$', NZD: '$', SGD: '$', GBP: '£', USD: '$' }[code] || '$';
    return `${symbol}${amount}`;
  }
  /* The subtotal: formatMoney with its currency code, but no ".00" on whole
     amounts - "$128 AUD", while real cents still show ("$127.50 AUD")
     (Maddie, 22 Oct 2026). Line prices keep formatMoney. */
  function formatMoneySubtotal(cents) {
    return formatMoney(cents).replace(/\.00(?= |$)/, '');
  }

  /* ---- SAVINGS IN DOLLARS (Maddie, 14 Oct 2026) -------------------------
     DISPLAY ONLY. Nothing here changes what is in the cart, a price, a line,
     a quantity or checkout - it only writes text into the drawer.
     A subscription line saves (one-time price - what she pays) x quantity,
     the same comparison the old "Saving X%" badge made, now shown in money
     because a percentage made the boosters look like the worse deal
     (Blend $20 on $99 = 20%, booster $10 on $59 = 17%).
     Returns null when the one-time price is not known yet, so callers can
     refuse to show a figure rather than show an understated one. */
  function subLineSavingCents(item) {
    /* The optimistic placeholder line has no real price yet (final_price 0),
       which would read as saving the whole one-time price. */
    if (!item || item._optimistic) return null;
    const h = getProductHandle(item);
    const c = h ? productPriceCache[h] : null;
    if (!c || !c.otpPrice) return null;
    let otpEquivalent = c.otpPrice;
    if (isDoubleSub(item.variant_id)) otpEquivalent = c.otpPrice * 2;
    /* The SUBSCRIPTION price, before any discount code (original_price), so a
       code is not counted as an "every order" saving - a first-order code is
       gone by month two (adversarial review, 14 Oct 2026). */
    const unit = item.original_price != null ? item.original_price : item.final_price;
    if (!(unit > 0)) return null;
    const per = otpEquivalent - unit;
    return per > 0 ? per * item.quantity : 0;
  }

  /* The subtotal with what the same subscription items cost one-time struck
     through, and a line under it saying how much is saved on every order.
     Only when EVERY subscription line's one-time price is known (else the
     plain subtotal, as before). Never while the cart is optimistic. Any
     error leaves the plain subtotal that render() already wrote. */
  function renderSubtotalSavings() {
    try {
      const line = document.getElementById('am-cart-saving-line');
      const plain = () => {
        if (subtotalEl && subtotalEl.dataset.withWas && cart) {
          subtotalEl.textContent = formatMoneySubtotal(cart.total_price);
          delete subtotalEl.dataset.withWas;
        }
        if (line) line.style.display = 'none';
      };
      if (!cart || !subtotalEl || isOptimisticState(cart)) { if (line) line.style.display = 'none'; return; }
      const subs = (cart.items || []).filter(i => isProduct(i.variant_id) && isSubscription(i.variant_id));
      if (!subs.length) return plain();
      let saved = 0;
      for (const i of subs) {
        const s = subLineSavingCents(i);
        if (s === null) return plain();
        saved += s;
      }
      if (saved <= 0) return plain();
      /* Struck = the same items at one-time prices, before any discount code.
         Built from the LINES, not cart.original_total_price: updateQuantity()
         re-renders locally with new quantities but leaves the cart-level
         totals stale, which put "$178" over a $79 cart after a minus (review,
         14 Oct 2026). Gifts count at what they cost her (final_line_price, $0),
         not their list price. */
      let before = 0;
      for (const i of (cart.items || [])) {
        if (isGift(i.variant_id)) { before += (i.final_line_price || 0); continue; }
        const unit = i.original_price != null ? i.original_price : i.final_price;
        before += (unit || 0) * i.quantity;
      }
      subtotalEl.innerHTML = `<s class="am-cart__subtotal-was">${formatMoneyShort(before + saved)}</s> ${formatMoneySubtotal(cart.total_price)}`;
      subtotalEl.dataset.withWas = '1';
      let el = line;
      if (!el) {
        const row = subtotalEl.closest('.am-cart__subtotal');
        if (!row) return;
        el = document.createElement('div');
        el.id = 'am-cart-saving-line';
        el.className = 'am-cart__saving-line';
        row.insertAdjacentElement('afterend', el);
      }
      el.textContent = `You're saving ${formatMoneyShort(saved)} on every order`;
      el.style.display = '';
    } catch (e) {
      try { console.warn('[AM Cart] subtotal savings not shown', e); } catch (_) {}
    }
  }

  function getGiftForVariant(variantId) {
    if (CUSTOMER_HAS_KIT) return null;  
    if (isOneTime(variantId)) return null;
    const market = getMarketForVariant(variantId);
    const kits = CONFIG.kits[market];
    if (isSingleSub(variantId)) return kits.single;
    if (isDoubleSub(variantId)) return kits.double;
    return null;
  }

  function getProductHandle(item) {
    if (item.url) {
      const match = item.url.match(/\/products\/([^?]+)/);
      if (match) return match[1];
    }
    return null;
  }

  /* CART LINES LINK TO THEIR PRODUCT PAGES.
     These were deliberately inert (onclick="return false") back when every
     region was pushed at the one shared AU Blend page, so a click would have
     sent a US or NZ customer to the wrong market's product. Each market now has
     its own Blend page, and the boosters have landing pages people genuinely
     want to read before committing - so the links are live.

     Two things keep them pointing at the right place:
       item.url    Shopify already resolves this per market
       ROOT        the /en-us/, /en-nz/ ... prefix, when item.url is absent
     Falls back to the handle map so a line is never left with a dead '#'. */
  function getProductUrl(item) {
    if (item && item.url) {
      const m = String(item.url).match(/\/products\/([^?#]+)/);
      if (m) return ROOT + 'products/' + m[1];
    }
    const handle = getProductHandle(item) || defaultHandleForVariant(item && item.variant_id);
    return handle ? ROOT + 'products/' + handle : '';
  }

  /* =========================================
     CACHE
     ========================================= */

  function getCachedCart() {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data.timestamp || (Date.now() - data.timestamp) > 600000) return null;
      return data.cart;
    } catch (e) { return null; }
  }

  function setCachedCart(cartData) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ cart: cartData, timestamp: Date.now() }));
    } catch (e) {}
  }

  /* =========================================
     PRODUCT PRICE CACHE
     ========================================= */

  async function fetchProductPrices(item) {
    if (isGift(item.variant_id)) return { otpPrice: null, singleSubPrice: null };

    const handle = getProductHandle(item);
    if (!handle) return { otpPrice: null, singleSubPrice: null };

    if (productPriceCache[handle] !== undefined) return productPriceCache[handle];

    try {
      const res = await fetchWithTimeout(`${ROOT}products/${handle}.js`);
      const product = await res.json();

      let otpPrice = null;
      let singleSubPrice = null;
for (const v of product.variants) {
        if (isOneTime(v.id)) otpPrice = v.price;
        if (isSubscription(v.id) && !isDoubleSub(v.id)) singleSubPrice = v.price;
      }
      const result = { otpPrice, singleSubPrice };
      if (otpPrice != null || singleSubPrice != null) productPriceCache[handle] = result;
      return result;
    } catch (e) {
      /* Do NOT cache the failure. A timeout used to mean no savings badge for
         that product for the rest of the session. */
      return { otpPrice: null, singleSubPrice: null };
    }
  }

  /* =========================================
     SELLING PLAN RESOLVER
     ========================================= */
  const sellingPlanCache = {};

async function getSellingPlanForVariant(variantId, handleHint) {
    if (!isSubscription(variantId)) return null;
    if (CONFIG.variantToSellingPlan[variantId]) return CONFIG.variantToSellingPlan[variantId];
    if (sellingPlanCache[variantId] !== undefined) return sellingPlanCache[variantId];
    try {
      const handle = handleHint || defaultHandleForVariant(variantId);
      const res = await fetchWithTimeout(`${ROOT}products/${handle}.js`, { credentials: 'same-origin' });
      const product = await res.json();
      for (const v of product.variants) {
        const alloc = v.selling_plan_allocations && v.selling_plan_allocations[0];
        sellingPlanCache[v.id] = alloc
          ? (alloc.selling_plan_id || (alloc.selling_plan && alloc.selling_plan.id) || null)
          : null;
      }
    } catch (e) {
      sellingPlanCache[variantId] = null;
    }
    return sellingPlanCache[variantId] || null;
  }

  // Resolve the selling plan valid in the CURRENT market for this line, read live
  // from the product JSON (not the hardcoded map). Lets a re-add attach the plan in any market.
  async function resolveMarketPlan(line) {
    const handle = getProductHandle(line) || defaultHandleForVariant(line.variant_id);
    try {
      const p = await fetchWithTimeout(`${ROOT}products/${handle}.js`, { credentials: 'same-origin' }).then(r => r.json());
      const v = p.variants.find(x => x.id === line.variant_id);
      const alloc = v && v.selling_plan_allocations && v.selling_plan_allocations[0];
      const id = alloc && (alloc.selling_plan_id || (alloc.selling_plan && alloc.selling_plan.id));
      if (id) return id;
    } catch (e) {}
    return CONFIG.variantToSellingPlan[line.variant_id] || null;
  }

  /* =========================================
     TIMED FETCH (in-app hang guard)
     Aborts a stalled request so callers' catch/finally always run.
     ========================================= */

  function fetchWithTimeout(url, opts, ms) {
    opts = opts || {};
    ms = (ms == null) ? 8000 : ms;
    const ctrl = new AbortController();
    const t = setTimeout(function () { ctrl.abort(); }, ms);
    return fetch(url, Object.assign({}, opts, { signal: ctrl.signal }))
      .finally(function () { clearTimeout(t); });
  }

  /* =========================================
     SHOPIFY CART API (with cache write-through)
     ========================================= */

  async function fetchCart() {
    const res = await fetchWithTimeout(`${ROOT}cart.js`, { credentials: 'same-origin' });
    const data = await res.json();
    setCachedCart(data);
    return data;
  }

  async function addToCartApi(items) {
    internalAddDepth++;
    try {
      const res = await fetchWithTimeout(`${ROOT}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) {
        /* Shopify puts the real reason in the body - "requires a selling plan",
           "sold out", "not available in this market". Throwing only the status
           is what made a refused add look like an empty drawer with no cause. */
        var why = '';
        try { var b = await res.json(); why = b.description || b.message || ''; } catch (e) {}
        var err = new Error('cart-add-' + res.status + (why ? ': ' + why : ''));
        err.status = res.status;
        err.shopifyMessage = why;
        console.error('[AM Cart] /cart/add.js refused', res.status, why, items);
        throw err;
      }
      return res.json();
    } finally {
      internalAddDepth--;
    }
  }

  async function changeItem(lineKey, quantity) {
    const res = await fetchWithTimeout(`${ROOT}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity })
    });
    if (!res.ok) throw new Error('cart-change-' + res.status);
    return res.json();
  }

  async function updateCartItems(updates) {
    const res = await fetchWithTimeout(`${ROOT}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!res.ok) throw new Error('cart-update-' + res.status);   // remove/qty step: never treat 422 as success
    return res.json();
  }

  async function clearCartApi() {
    const res = await fetchWithTimeout(`${ROOT}cart/clear.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res.ok) throw new Error('cart-clear-' + res.status);
    return res.json();
  }

  /* =========================================
     GIFT LOGIC
     ========================================= */

  function computeDesiredGifts(cartItems) {
    if (CUSTOMER_HAS_KIT) return {};
    const market = detectMarket(cartItems);
    const kits = CONFIG.kits[market] || CONFIG.kits.auEx;
    let singleSubQty = 0, doubleSubQty = 0;

    for (const item of cartItems) {
      if (isSingleSub(item.variant_id)) singleSubQty += item.quantity;
      if (isDoubleSub(item.variant_id)) doubleSubQty += item.quantity;
    }

    const totalServings = singleSubQty + (doubleSubQty * 2);

    const gifts = [];

    if (totalServings === 0) {
      // No subs - no gifts
    } else if (totalServings === 1) {
      gifts.push({ id: kits.single, quantity: 1 });
    } else if (totalServings >= 2) {
      gifts.push({ id: kits.double, quantity: 1 });
    }

    const merged = {};
    for (const g of gifts) merged[g.id] = (merged[g.id] || 0) + g.quantity;
    return merged;
  }

  async function syncGifts(cartData) {
    const desired = computeDesiredGifts(cartData.items);
    const currentGifts = {};
    for (const item of cartData.items) {
      if (isGift(item.variant_id)) {
        if (!currentGifts[item.variant_id]) currentGifts[item.variant_id] = { totalQty: 0, keys: [] };
        currentGifts[item.variant_id].totalQty += item.quantity;
        currentGifts[item.variant_id].keys.push(item.key);
      }
    }

    let correct = true;
    for (const vid of Object.keys(desired).map(Number)) {
      const cur = currentGifts[vid];
      if (!cur || cur.totalQty !== desired[vid] || cur.keys.length > 1) { correct = false; break; }
    }
    for (const vid of Object.keys(currentGifts).map(Number)) {
      if (!desired[vid]) { correct = false; break; }
    }
    if (correct) return null;

    const updates = {};
    for (const info of Object.values(currentGifts)) {
      for (const key of info.keys) updates[key] = 0;
    }
    if (Object.keys(updates).length > 0) await updateCartItems(updates);

    const toAdd = [];
    for (const [vid, qty] of Object.entries(desired)) {
      toAdd.push({ id: parseInt(vid), quantity: qty, properties: { '_gift': 'true' } });
    }
    if (toAdd.length > 0) await addToCartApi(toAdd);

    return await fetchCart();
  }

  // A booster must never stand alone: it is an add-on product and is priced as one.
  // This is the ONLY thing enforcing that rule, so it has to run on every path
  // that can leave a booster in the cart without the Blend - not just when the
  // drawer is opened. See the call sites below.
  //
  // Single-flight: it adds to the cart and then re-reads it, and several of its
  // callers fire on a cart change, so without this flag a slow network can have
  // two of them adding a Blend each.
  let dlbGuardRunning = false;
  async function ensureDlbForBoosters(cartData) {
    if (dlbGuardRunning) return null;
    if (!cartData || !cartData.items) return null;
    const hasBooster = cartData.items.some(i => isBooster(i.variant_id));
    const hasDlb = cartData.items.some(i => isSingleSub(i.variant_id) || isDoubleSub(i.variant_id) || isDlbOneTime(i.variant_id));
    if (!hasBooster || hasDlb) return null;
    const idx = currentMarketIndex();
    const dlbVid = CONFIG.singleSub[idx < 0 ? 0 : idx];
    if (!dlbVid) return null;
    const line = { id: dlbVid, quantity: 1 };
    const plan = CONFIG.variantToSellingPlan[dlbVid] || await resolveMarketPlan({ variant_id: dlbVid });
    if (plan) line.selling_plan = plan;
    dlbGuardRunning = true;
    try {
      await addToCartApi([line]);
      const fresh = await fetchCart();
      const fixed = await syncGifts(fresh);
      return fixed || fresh;
    } catch (e) {
      console.error('[AM Cart] could not attach the Blend to an orphaned booster:', e);
      return null;
    } finally {
      dlbGuardRunning = false;
    }
  }

  /* =========================================
     RENDERING
     ========================================= */

  function getProductImageUrl(item) {
    if (item.image) return item.image.replace(/(\.[a-z]+)(\?|$)/, '_200x200$1$2');
    const vid = item.variant_id;
    if (vid === CONFIG.kits.auEx.single || vid === CONFIG.kits.ex.single || vid === CONFIG.kits.nr.single) {
      return CONFIG.fallbackImages.singleKit;
    }
    if (vid === CONFIG.kits.auEx.double || vid === CONFIG.kits.ex.double || vid === CONFIG.kits.nr.double) {
      return CONFIG.fallbackImages.doubleKit;
    }
    if (vid === CONFIG.shaker) {
      return CONFIG.fallbackImages.shaker;
    }
    return 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" fill="%23f0f0f0"><rect width="76" height="76"/></svg>');
  }

  /* DECLARED HERE, NOT DOWN BY amCapacity(). getMaxQty() and renderCapNotice()
     both read it and are reachable from render(); a `const` declared after them
     is a TDZ crash waiting for the first synchronous render() in init(). */
  console.log('[AM Cart] build 2026-10-02 cap-notice (DEV)');

  const MAX_BOOSTERS = 2;

  function getMaxQty(variantId) {
    /* WITH BOOSTERS IN THE CART THE BLEND TOPS OUT AT TWO TUBS, however you get
       there: Single Sub x2, or Double Sub x1. Those are the only Blend shapes
       the bundle pricing and the shipper table cover. Blend-only customers are
       untouched and keep maxSingleSub / maxDoubleSub. */
    const _items = (cart && cart.items) || [];
    const _hasBooster = _items.some(i => isBooster(i.variant_id));
    const lineCap = isSingleSub(variantId)
      ? (_hasBooster ? Math.min(2, CONFIG.maxSingleSub) : CONFIG.maxSingleSub)
      : isDoubleSub(variantId)
        ? (_hasBooster ? 1 : CONFIG.maxDoubleSub)
        : 99;
    /* DOUBLE SUB IS CAPPED AT 1 ONCE A BOOSTER IS IN THE CART.
       Blend-only customers keep the existing limit of 2 - that predates
       boosters and is not ours to take away. But Double at qty 2 is 4 tubs,
       and Double + boosters is not a combination the pricing or the shipper
       table covers, so the moment an add-on appears the Blend line is one
       Double and no more. */

    /* BOOSTERS ARE CAPPED ACROSS THE WHOLE CART, NOT PER LINE.
       This returned 99, so the drawer's + button happily went past two - the
       PDP refused a third while the drawer handed one out. And a per-line cap
       of 2 would be wrong too: one Sleep + one Hormone is already AT the cap,
       so neither line may increment. Budget = MAX_BOOSTERS minus every OTHER
       booster line, floored at this line's current quantity so an existing
       over-cap cart renders instead of showing a negative maximum. */
    if (isBooster(variantId)) {
      let others = 0, mine = 0;
      for (const i of _items) {
        if (!isBooster(i.variant_id)) continue;
        if (i.variant_id === variantId) mine += i.quantity; else others += i.quantity;
      }
      /* TWO BOOSTER UNITS PER ORDER, FULL STOP - the Blend quantity does not
         come into it. One Blend carrying two boosters is the normal shape of
         the bundle, not an edge case.
         A "booster may never outnumber the Blend" rule used to live in
         canIncrease(), which is why one Blend + one booster refused to go to
         two. It was never a business rule and it is gone. */
      return Math.max(mine, MAX_BOOSTERS - others);
    }
    /* maxTotalSub caps TOTAL servings across every Blend line (Double counts 2).
       Same story: it lived only in canIncrease(). */
    /* WITH A BOOSTER IN THE CART: AT MOST 2 TUBS OF BLEND IN TOTAL, one-time
       included (Maddie, 14 Oct 2026). The line caps above did not stop Single x2
       + Double x1 (4 tubs) or a one-time tub on top. Without a booster nothing
       here changes: the budget is maxTotalSub and one-time is not counted. */
    if (isSubscription(variantId) || (_hasBooster && isDlbOneTime(variantId))) {
      let servings = 0, mineQty = 0;
      for (const i of _items) {
        if (isSingleSub(i.variant_id)) servings += i.quantity;
        else if (isDoubleSub(i.variant_id)) servings += i.quantity * 2;
        else if (_hasBooster && isDlbOneTime(i.variant_id)) servings += i.quantity;
        if (i.variant_id === variantId) mineQty += i.quantity;
      }
      const totalCap = _hasBooster ? 2 : CONFIG.maxTotalSub;
      const per = isDoubleSub(variantId) ? 2 : 1;
      const headroom = Math.floor((totalCap - servings) / per);
      return Math.max(mineQty, Math.min(lineCap, mineQty + Math.max(0, headroom)));
    }
    return 99;
  }

  /* savingsCents: what this subscription line saves against the one-time
     price (0 = no badge). Was a percentage until 14 Oct 2026. */
  function renderProductItem(item, savingsCents) {
    const maxQty = getMaxQty(item.variant_id);
    const atMax = item.quantity >= maxQty;
    const productUrl = getProductUrl(item);
    const isOptimistic = item._optimistic === true;

    /* EVERY LINE DESCRIBES WHAT IS IN THE BOX, IN THE SAME SHAPE.
       The boosters used to read a bare "30 serves" next to the Blend's
       "1 tub / 30 serves", and the one-time Blend read "One-Time Purchase" -
       which the section heading directly above it already says. Units differ
       (the Blend comes in tubs, the boosters in bottles); the format does not.
       14 Oct 2026 (Maddie): no "tub" anywhere a customer reads it - "tubs of
       the Blend" read as too informal. The Blend line is now serves only. */
    const qty = item.quantity;
    let variantLabel = '';
    if (isDoubleSub(item.variant_id)) {
      variantLabel = `${60 * qty} serves`;
    } else if (isSingleSub(item.variant_id) || isDlbOneTime(item.variant_id)) {
      /* The one-time Blend is the same 1-pack as the single subscription, so it
         gets the same sentence. Whether it recurs is the heading's job. */
      variantLabel = `${30 * qty} serves`;
    } else if (isBooster(item.variant_id)) {
      const b = BOOSTER_BY_VARIANT[item.variant_id];
      /* Both figures come from CONFIG so this follows the carton, not a guess. */
      /* 16 Oct 2026 (Maddie): serves only, like the Blend line - no tablet count. */
      const perPack = (b && b.serving && parseInt(b.serving, 10)) || 30;
      variantLabel = `${perPack * qty} serves`;
    } else if (isOneTime(item.variant_id)) {
      variantLabel = 'One-Time Purchase';
    }

    const savingsHtml = savingsCents > 0 && !isOptimistic
      ? `<span class="am-cart__line-savings">Saving ${formatMoneyShort(savingsCents)}</span>`
      : '';

    const priceHtml = isOptimistic
      ? `<span class="am-cart__line-price" style="opacity:0.5;font-weight:400;font-size:13px;">Adding...</span>`
      : `<span class="am-cart__line-price">${formatMoney(item.final_line_price)}</span>`;

    const trashIcon = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M3 6H5H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 6V4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V6M19 6V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V6H19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    return `
      <div class="am-cart__line-item" data-key="${item.key}" data-variant-id="${item.variant_id}">
        ${productUrl
          ? `<a href="${esc(productUrl)}" class="am-cart__line-img-link" data-am-link="1">
               <img class="am-cart__line-img" src="${esc(getProductImageUrl(item))}" alt="${esc(item.product_title)}" loading="lazy" />
             </a>`
          : `<span class="am-cart__line-img-link">
               <img class="am-cart__line-img" src="${esc(getProductImageUrl(item))}" alt="${esc(item.product_title)}" loading="lazy" />
             </span>`}
        <div class="am-cart__line-info">
          ${productUrl
            ? `<a href="${esc(productUrl)}" class="am-cart__line-name-link" data-am-link="1">
                 <p class="am-cart__line-name">${esc(item.product_title)}</p>
               </a>`
            : `<p class="am-cart__line-name">${esc(item.product_title)}</p>`}
          <p class="am-cart__line-variant">${variantLabel}</p>
          <div class="am-cart__line-price-row">
            ${priceHtml}
            ${savingsHtml}
          </div>
          <div class="am-cart__qty-wrap">
            <button type="button" class="am-cart__qty-btn is-remove" data-action="${item.quantity <= 1 ? 'remove' : 'decrease'}" data-key="${item.key}" data-variant-id="${item.variant_id}" ${isOptimistic ? 'disabled' : ''}>
              ${item.quantity <= 1 ? trashIcon : '<span style="font-size:18px;">−</span>'}
            </button>
            <span class="am-cart__qty-val">${item.quantity}</span>
            <button type="button" class="am-cart__qty-btn" data-action="increase" data-key="${item.key}" data-variant-id="${item.variant_id}" ${atMax || isOptimistic ? 'disabled' : ''}>
              <span style="font-size:18px;">+</span>
            </button>
          </div>
        </div>
      </div>
    `;
  }

  /* ---------------------------------------------------------------------------
     ONE max-quantity notice for the whole group, not one under every line.
     It names the limit that was hit rather than just announcing a limit, so the
     customer knows what to change. Returns '' when nothing is capped.
     ------------------------------------------------------------------------ */
  /* ONE SET OF LIMIT SENTENCES for the drawer notice and the refused-add
     flash (mirrored in main-cart.liquid). Plain and short for a first-time
     reader: no "tubs", the product named in full, no numbers to decode for the
     Blend. Wording approved by Maddie 13-14 Oct 2026. */
  function capSentence(boosterCapped, blendCapped) {
    if (boosterCapped && blendCapped) return "Your order is full. That's the most we can send at once.";
    if (boosterCapped) return "You've reached the limit of " + MAX_BOOSTERS + " targeted support products per order.";
    if (blendCapped) return "You've added the most Daily Longevity Blend we can send in one order.";
    return '';
  }

  function renderCapNotice(items) {
    items = items || [];
    /* Optimistic lines ARE counted - getMaxQty() counts them, and if this did
       not, the notice stayed silent during the optimistic window while the +
       buttons were already capped. The two must agree. */
    var tubs = 0, boosterUnits = 0, hasBooster = false;
    /* BOOSTERS ARE COUNTED ACROSS THE WHOLE CART, the Blend per section
       (adversarial review, 14 Oct 2026). getMaxQty() - which greys out the +
       buttons - sees the whole cart; this used to see only its own section, so
       a booster in the one-time section left the subscription section's + greyed
       out with no notice saying why, while /cart (whole cart) did say why. */
    ((cart && cart.items) || items).forEach(function (i) {
      if (isBooster(i.variant_id)) { boosterUnits += i.quantity; hasBooster = true; }
    });
    /* Without a booster the Blend is counted per section, subscriptions only,
       exactly as before. With one, the 2-tub rule covers the whole cart and
       one-time Blend too (Maddie, 14 Oct 2026), so count it that way - and only
       say so under a section that actually holds Blend. */
    var sectionHasBlend = items.some(function (i) {
      return isSingleSub(i.variant_id) || isDoubleSub(i.variant_id) || isDlbOneTime(i.variant_id);
    });
    (hasBooster ? ((cart && cart.items) || items) : items).forEach(function (i) {
      if (isDoubleSub(i.variant_id)) tubs += i.quantity * 2;
      else if (isSingleSub(i.variant_id)) tubs += i.quantity;
      else if (hasBooster && isDlbOneTime(i.variant_id)) tubs += i.quantity;
    });
    if (hasBooster && !sectionHasBlend) tubs = 0;

    /* REPORT THE CAP, NOT THE CONTENTS.
       This counted the tubs actually in the cart, which went wrong two ways:
       a cart sitting at 3 of an allowed 4 announced "maximum of 3 tubs" the
       moment any one line hit its own ceiling, and the PDP refusal - which
       quotes the real cap - then disagreed with it. Quoting the cap is true in
       both places and stays sane if a stale cart somehow holds more. */
    var tubCap = hasBooster ? 2 : CONFIG.maxTotalSub;
    var boosterCapped = boosterUnits >= MAX_BOOSTERS;
    var blendCapped = tubs >= tubCap;
    if (!boosterCapped && !blendCapped) return '';

    var sentence = capSentence(boosterCapped, blendCapped);
    if (!sentence) return '';

    return '<div class="am-cart__max-msg is-visible" role="status" data-cap-notice>' +
             '<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 8V12M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
             '<span>' + sentence + '</span>' +
           '</div>';
  }

  function getGiftDisplayInfo(variantId) {
    return {
      [CONFIG.kits.auEx.single]: { name: 'Free Welcome Kit', desc: 'Container & Drink Bottle' },
      [CONFIG.kits.auEx.double]: { name: 'Free Welcome Kit', desc: 'Container & 2 Drink Bottles' },
      [CONFIG.kits.ex.single]: { name: 'Free Welcome Kit', desc: 'Container & Drink Bottle' },
      [CONFIG.kits.ex.double]: { name: 'Free Welcome Kit', desc: 'Container & 2 Drink Bottles' },
      [CONFIG.kits.nr.single]: { name: 'Free Welcome Kit', desc: 'Container & Drink Bottle' },
      [CONFIG.kits.nr.double]: { name: 'Free Welcome Kit', desc: 'Container & 2 Drink Bottles' },
      [CONFIG.shaker]: { name: 'Free Drink Bottle', desc: '400ml Drink Bottle' }
    }[variantId] || { name: 'Free Gift', desc: '' };
  }

  function renderGiftItem(item) {
    const info = getGiftDisplayInfo(item.variant_id);
    const qtyLabel = item.quantity > 1 ? ` × ${item.quantity}` : '';
    return `
      <div class="am-cart__gift-item" data-key="${item.key}" data-variant-id="${item.variant_id}">
        <img class="am-cart__gift-img" src="${esc(getProductImageUrl(item))}" alt="${info.name}" loading="lazy" />
        <div class="am-cart__gift-info">
          <p class="am-cart__gift-name">${info.name}${qtyLabel}</p>
          <p class="am-cart__gift-desc">${info.desc}</p>
        </div>
        <span class="am-cart__gift-pill">Free</span>
      </div>
    `;
  }

  /* =========================================
     PROMO + SHIPPING BAR + UPSELL
     ========================================= */

function renderPromo(cartData) {
    const discounts = cartData.cart_level_discount_applications || [];
    const discountCode = discounts.find(d => d.type === 'discount_code');
    const hasDiscount = discountCode && cartData.total_discount > 0;

    if (promoDefault && promoApplied) {
      if (hasDiscount) {
        promoDefault.style.display = 'none';
        promoApplied.style.display = '';
        if (promoPillCode) promoPillCode.textContent = discountCode.title;
        if (promoPillAmount) promoPillAmount.textContent = `−${formatMoney(cartData.total_discount)}`;
      } else {
        promoDefault.style.display = '';
        promoApplied.style.display = 'none';
      }
    }

    if (discountDefault && discountApplied) {
      if (hasDiscount) {
        discountDefault.style.display = 'none';
        discountApplied.style.display = '';
        if (discountCodeEl) discountCodeEl.textContent = discountCode.title;
        if (discountAmountEl) discountAmountEl.textContent = `(−${formatMoney(cartData.total_discount)})`;
      } else {
        discountDefault.style.display = '';
        discountApplied.style.display = 'none';
      }
    }
  }

  function renderShippingBar(cartData) {
    if (!SHOW_SHIPBAR) { if (shippingBar) shippingBar.style.display = 'none'; return; }   // theme-editor toggle
    const productItems = cartData.items.filter(i => isProduct(i.variant_id));
    if (productItems.length === 0) {
      shippingBar.style.display = 'none';
      return;
    }

    if (isOptimisticState(cartData)) {
      shippingBar.style.display = 'none';
      return;
    }

    shippingBar.style.display = '';
    const hasSub = productItems.some(i => isSubscription(i.variant_id));
    const hasOtpOnly = !hasSub && productItems.some(i => isOneTime(i.variant_id));
    const isAu = isAuMarket();

    if (isAu) {
      const subtotal = cartData.total_price;
      const threshold = CONFIG.auFreeShippingCents;
      if (subtotal >= threshold) {
        shippingMsg.innerHTML = `You've earned free shipping. <strong>Perfect.</strong>`;
        shippingFill.style.width = '100%';
        shippingFill.classList.add('is-complete');
      } else {
        const remaining = (threshold - subtotal) / 100;
        const currency = window.Shopify?.currency?.active || 'AUD';
        const symbol = { AUD: '$', NZD: '$', SGD: '$', GBP: '£', USD: '$' }[currency] || '$';
        shippingMsg.innerHTML = `You're <span class="am-shipping-highlight">${symbol}${remaining.toFixed(2)} ${currency}</span> away from free shipping`;
        const pct = Math.min((subtotal / threshold) * 100, 100);
        shippingFill.style.width = pct + '%';
        shippingFill.classList.remove('is-complete');
      }
    } else {
      if (hasSub) {
        shippingMsg.innerHTML = `You've earned free shipping. <strong>Perfect.</strong>`;
        shippingFill.style.width = '100%';
        shippingFill.classList.add('is-complete');
      } else if (hasOtpOnly) {
        shippingMsg.innerHTML = `Subscribe to unlock <span class="am-shipping-highlight">bonuses and savings</span>`;
        shippingFill.style.width = '0%';
        shippingFill.classList.remove('is-complete');
      }
    }
  }

  function renderUpsell(cartData) {
    if (!upsellSub || !upsellSubBtn || !upsellSubMsg) { return; }
    if (!SHOW_UPSELL) { upsellSub.style.display = 'none'; return; }   // theme-editor toggle
    // Don't offer the switch until the cart has reconciled to real server keys —
    // clicking it mid-optimistic sends a non-matching key to cart/update and races the add.
    if (isOptimisticState(cartData)) { upsellSub.style.display = 'none'; return; }
    const productItems = cartData.items.filter(i => isProduct(i.variant_id));
    const otpItemsList = productItems.filter(i => isOneTime(i.variant_id));
    const hasSub = productItems.some(i => isSubscription(i.variant_id));

    if (otpItemsList.length > 0 && !hasSub) {
      const otpItem = otpItemsList.find(i => CONFIG.otpToSingleSub[i.variant_id]);
      const subVariantId = otpItem ? CONFIG.otpToSingleSub[otpItem.variant_id] : null;
      if (otpItem && subVariantId) {
        upsellSubBtn.dataset.otpKey = otpItem.key;
        upsellSubBtn.dataset.otpVariantId = otpItem.variant_id;
        upsellSubBtn.dataset.subVariantId = subVariantId;

        upsellSubMsg.textContent = 'Switch to a subscription to save and get a free Welcome Kit.';
        upsellSub.style.display = '';

        const handle = getProductHandle(otpItem);
        const cached = handle ? productPriceCache[handle] : null;
        if (cached && cached.otpPrice && cached.singleSubPrice && cached.otpPrice > cached.singleSubPrice) {
          const savingsAmount = (cached.otpPrice - cached.singleSubPrice) / 100;
          const currency = window.Shopify?.currency?.active || 'AUD';
          const symbol = { AUD: '$', NZD: '$', SGD: '$', GBP: '£', USD: '$' }[currency] || '$';
          upsellSubMsg.textContent = `Switch to a subscription to save ${symbol}${savingsAmount.toFixed(0)} and get a free Welcome Kit.`;
        } else {
          fetchProductPrices(otpItem).then(prices => {
            if (prices.otpPrice && prices.singleSubPrice && prices.otpPrice > prices.singleSubPrice) {
              const savingsAmount = (prices.otpPrice - prices.singleSubPrice) / 100;
              const currency = window.Shopify?.currency?.active || 'AUD';
              const symbol = { AUD: '$', NZD: '$', SGD: '$', GBP: '£', USD: '$' }[currency] || '$';
              upsellSubMsg.textContent = `Switch to a subscription to save ${symbol}${savingsAmount.toFixed(0)} and get a free Welcome Kit.`;
            }
          }).catch(() => {});
        }
        return;
      }
    }
    upsellSub.style.display = 'none';
  }

  async function handleSwitchToSub() {
    // Ignore while another mutation runs OR while the cart is still optimistic
    // (a stale/optimistic OTP key would not match a server line).
    if (isUpdating || isOptimisticState(cart)) return;
    isUpdating = true;
    try {
      const subVariantId = parseInt(upsellSubBtn.dataset.subVariantId);
      const otpVariantId = parseInt(upsellSubBtn.dataset.otpVariantId);

      // Re-find the one-time line from the LIVE cart so we use the real server key,
      // not whatever key was on the button when it was last rendered.
      const otpItem = cart.items.find(i => i.variant_id === otpVariantId && isOneTime(i.variant_id));
      if (!otpItem) return;
      const otpKey = otpItem.key;   // real server line key (captured before optimistic mutation)

      // Save real gift keys before we modify
      const currentRealGifts = cart.items.filter(i => isGift(i.variant_id) && !i.key.startsWith('temp-gift-') && !i.key.startsWith('optimistic-'));
      realGiftKeys = currentRealGifts.map(i => i.key);

      /* THE BOOSTERS HAVE TO COME WITH IT.
         This used to convert the Blend only, leaving any booster on its
         one-time variant. The customer then checked out with a subscription
         Blend and a booster bought outright - no add-on plan, no second
         shipment, and nothing in Recharge tying them together. Every booster
         one-time in the cart converts to its subscription variant on the
         add-on plan, in the same pair of calls. */
      const boosterOtpLines = cart.items.filter(i =>
        isBoosterOtp(i.variant_id) && BOOSTER_BY_VARIANT[i.variant_id]);

      // OPTIMISTIC: immediately show the subscription item in place of OTP
      otpItem.variant_id = subVariantId;
      otpItem.key = 'optimistic-sub-' + Date.now();
      otpItem._optimistic = true;

      const boosterSwaps = boosterOtpLines.map(line => {
        const b = BOOSTER_BY_VARIANT[line.variant_id];
        const swap = { key: line.key, sub: b.sub, qty: line.quantity, handle: b.handle, plan: b.addonPlan };
        line.variant_id = b.sub;
        line.key = 'optimistic-bsub-' + b.key + '-' + Date.now();
        line._optimistic = true;
        return swap;
      });

      const desiredGifts = computeDesiredGifts(cart.items.filter(i => !isGift(i.variant_id)));
      cart.items = cart.items.filter(i => !isGift(i.variant_id));
      for (const [vid, qty] of Object.entries(desiredGifts)) {
        cart.items.push({
          key: 'temp-gift-' + vid,
          variant_id: parseInt(vid),
          quantity: qty,
          final_price: 0,
          final_line_price: 0,
          original_price: 0,
          original_line_price: 0,
          product_title: 'Free Gift',
          image: null,
          url: '',
          _optimistic: true
        });
      }

      cart.item_count = cart.items.filter(i => !isGift(i.variant_id)).reduce((sum, i) => sum + i.quantity, 0);
      cart.total_price = cart.items.reduce((sum, i) => sum + (i.final_line_price || 0), 0);
      lockCheckout('Updating cart...');
      render(cart);

      // Single update call: zero OTP + zero old gifts
      const updates = {};
      updates[otpKey] = 0;
      for (const sw of boosterSwaps) updates[sw.key] = 0;
      for (const gk of realGiftKeys) {
        updates[gk] = 0;
      }
      realGiftKeys = [];
      await updateCartItems(updates);

      // Single add call: sub + correct gift — WITH its selling plan (cart fix)
      const giftId = getGiftForVariant(subVariantId);
      const handleHint = getProductHandle(otpItem) || defaultHandleForVariant(subVariantId);
      const sellingPlan = await getSellingPlanForVariant(subVariantId, handleHint);
      const subLine = { id: subVariantId, quantity: 1 };
      if (sellingPlan) subLine.selling_plan = sellingPlan;
      const items = [subLine];
      for (const sw of boosterSwaps) {
        /* Resolve per market first; fall back to the add-on plan in CONFIG so a
           failed lookup still attaches a plan rather than adding a planless
           subscription line. */
        let bPlan = null;
        try { bPlan = await getSellingPlanForVariant(sw.sub, sw.handle); } catch (e) {}
        if (!bPlan) bPlan = CONFIG.variantToSellingPlan[sw.sub] || sw.plan || null;
        const bLine = { id: sw.sub, quantity: sw.qty };
        if (bPlan) bLine.selling_plan = bPlan;
        else console.error('[AM Cart] no selling plan for booster ' + sw.sub + ' — refusing to add it planless');
        if (bPlan) items.push(bLine);
      }
      if (giftId) items.push({ id: giftId, quantity: 1, properties: { '_gift': 'true' } });
      await addToCartApi(items);

      // Reconcile to real server state
      const finalCart = await fetchCart();
      await render(finalCart);
    } catch (err) {
      console.error('[AM Cart] Error switching to sub:', err);
      try {
        const recoveryCart = await fetchCart();
        await render(recoveryCart);
      } catch (e) {}
    } finally {
      isUpdating = false;
      // Never leave the checkout button locked if we bailed before a clean render.
      if (!isOptimisticState(cart)) unlockCheckout();
    }
  }

  /* =========================================
     MAIN RENDER
     ========================================= */

  async function render(cartData) {
    cart = cartData;
    /* EVERY cart change ends up here - add, remove, quantity, gift sync, heal.
       Dispatching from addRoutine only (as this first did) meant the booster
       PDP never heard about a quantity change or a Clear All, so its offers
       stayed greyed out until the page was reloaded. One event, one place. */
    try { document.dispatchEvent(new CustomEvent('am:cart-updated', { detail: { cart: cartData } })); } catch (e) {}
    const productItems = cart.items.filter(i => isProduct(i.variant_id));
    const giftItemsList = cart.items.filter(i => isGift(i.variant_id));
    const subProductItems = productItems
      .filter(i => isSubscription(i.variant_id))
      .sort((a, b) => {
        const aBooster = isBooster(a.variant_id) ? 1 : 0;
        const bBooster = isBooster(b.variant_id) ? 1 : 0;
        return aBooster - bBooster;
      });
    const otpProductItems = productItems
      .filter(i => isOneTime(i.variant_id))
      .sort((a, b) => {
        const aBooster = isBooster(a.variant_id) ? 1 : 0;
        const bBooster = isBooster(b.variant_id) ? 1 : 0;
        return aBooster - bBooster;
      });
    const hasItems = productItems.length > 0;

    emptyEl.style.display = hasItems ? 'none' : '';
    itemsEl.style.display = hasItems ? '' : 'none';
    footerEl.style.display = hasItems ? '' : 'none';
    const loadingEl = document.getElementById('am-cart-loading');
    if (loadingEl) loadingEl.style.display = 'none';

    /* Keyed by LINE key, not variant: the amount is for the whole line, and the
       same variant can sit on two lines (review, 14 Oct 2026). */
    let savingsMap = {};
    for (const item of subProductItems) {
      const s = subLineSavingCents(item);          // cents for the whole line, null = price not known yet
      if (s !== null && s > 0) savingsMap[item.key] = s;
    }

    if (subProductItems.length > 0) {
      subSection.style.display = '';
      subItems.innerHTML = subProductItems.map(i => renderProductItem(i, savingsMap[i.key] || 0)).join('');
    } else {
      subSection.style.display = 'none';
      subItems.innerHTML = '';
    }
    showPendingFlash();

    if (otpProductItems.length > 0) {
      otpSection.style.display = '';
      otpItems.innerHTML = otpProductItems.map(i => renderProductItem(i, 0)).join('');
    } else {
      otpSection.style.display = 'none';
      otpItems.innerHTML = '';
    }

    /* THE NOTICE GOES UNDER THE SECTION THAT IS ACTUALLY CAPPED.
       An earlier version computed one notice for the whole cart and appended it
       to whichever section was last. In a Single Sub x3 + One-Time cart - no
       boosters at all - that printed "at its maximum of 3 tubs" under the
       One-Time heading, next to a line whose + was still live, while the capped
       subscription line above said nothing. One notice per section, each
       describing only its own lines, is both correct and still far from the
       per-line repetition this replaced. */
    const subCapHtml = renderCapNotice(subProductItems);
    if (subCapHtml && subProductItems.length > 0) subItems.insertAdjacentHTML('beforeend', subCapHtml);
    const otpCapHtml = renderCapNotice(otpProductItems);
    /* A booster subscription AND a booster one-time sit in different sections
       but share one cap, so both sections would print the identical sentence.
       Show it once. Different text means the sections are capped for genuinely
       different reasons and both are worth saying. */
    if (otpCapHtml && otpProductItems.length > 0 && otpCapHtml !== subCapHtml) {
      otpItems.insertAdjacentHTML('beforeend', otpCapHtml);
    }

    if (giftItemsList.length > 0) {
      giftsSection.style.display = '';
      giftsDivider.style.display = '';
      giftItems.innerHTML = giftItemsList.map(renderGiftItem).join('');
    } else {
      giftsSection.style.display = 'none';
      giftsDivider.style.display = 'none';
      giftItems.innerHTML = '';
    }

    clearWrap.style.display = hasItems ? '' : 'none';
    if (boostersEl) {
      /* BOOSTERS ARE AUSTRALIA-ONLY.
         They are listed with the TGA for the Australian market and are not
         sold anywhere else, so a NZ, SG, US or GB customer must never be
         offered one. This carousel had no market gate at all - it rendered
         wherever the drawer did. */
      if (!SHOW_BOOSTERS || !isAuMarket()) {                 // theme-editor toggle + AU gate
        boostersEl.style.display = 'none';
      } else {
        boostersEl.style.display = hasItems ? '' : 'none';
        if (hasItems) buildBoosterCarousel();
      }
    }

    if (isOptimisticState(cart)) {
      subtotalEl.textContent = '';
      lockCheckout('Adding to cart...');
    } else {
      subtotalEl.textContent = formatMoneySubtotal(cart.total_price);
      unlockCheckout();
    }
    renderSubtotalSavings();   // display only; falls back to the plain subtotal above

    renderShippingBar(cartData);
    renderUpsell(cartData);
    renderPromo(cartData);
    updateCartCount(cart.item_count);

    for (const item of subProductItems) {
      if (savingsMap[item.key] !== undefined || item._optimistic) continue;
      const key = item.key;
      fetchProductPrices(item).then(prices => {
        if (!prices || !prices.otpPrice) return;
        /* Work from the line AS IT IS NOW, found by its key. The cart may have
           re-rendered since this started (e.g. an optimistic add became real),
           and the captured item's price/quantity can be stale - that is how a
           "Saving $99.00" landed next to a $20 footer (review, 14 Oct 2026). */
        const cur = ((cart && cart.items) || []).find(i => i.key === key);
        if (!cur || cur._optimistic) return;
        const cents = subLineSavingCents(cur);
        if (cents && cents > 0) {
          const el = document.querySelector(`[data-key="${key}"] .am-cart__line-price-row`);
          if (el && !el.querySelector('.am-cart__line-savings')) {
            el.insertAdjacentHTML('beforeend', `<span class="am-cart__line-savings">Saving ${formatMoneyShort(cents)}</span>`);
          }
        }
        renderSubtotalSavings();   // this price may have been the last one missing
      }).catch(e => { try { console.warn('[AM Cart] price lookup failed', e); } catch (_) {} });
    }
  }

  function updateCartCount(count) {
    if (regionSyncing && count === 0) return;   // hold the number steady during a market swap
    document.querySelectorAll('cart-count').forEach(el => {
      el.textContent = count;
      el.classList.toggle('opacity-0', count === 0);
    });
    document.querySelectorAll('.count-bubble').forEach(el => {
      el.textContent = count;
      el.classList.toggle('opacity-0', count === 0);
    });
  }

  /* =========================================
     OPTIMISTIC LINE ITEM BUILDER
     ========================================= */

  function buildOptimisticItem(variantId, quantity, sellingPlan) {
    let productTitle = 'Daily Longevity Blend';
    let productImage = null;
    let productHandle = defaultHandleForVariant(variantId);
    let pricePerUnit = 0;

    if (window.location.pathname.includes('/products/')) {
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) productTitle = ogTitle.content.split(/\s*[-–—|]\s*/)[0].trim();

      const ogImage = document.querySelector('meta[property="og:image"]');
      if (ogImage) productImage = ogImage.content;

      const handleMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
      if (handleMatch) productHandle = handleMatch[1];

      const priceEl = document.querySelector('[data-price-cents], .product-price, .price__current');
      if (priceEl?.dataset?.priceCents) {
        pricePerUnit = parseInt(priceEl.dataset.priceCents);
      }
    }

    if (!pricePerUnit && isSubscription(variantId)) {
      /* Use THIS variant's own product, not whatever happened to be cached
         first - that could be a booster priming a Blend line, or the reverse. */
      const ownHandle = defaultHandleForVariant(variantId);
      const handles = ownHandle && productPriceCache[ownHandle] ? [ownHandle] : Object.keys(productPriceCache);
      if (handles.length > 0) {
        const cached = productPriceCache[handles[0]];
        if (cached && cached.singleSubPrice) {
          pricePerUnit = isDoubleSub(variantId) ? cached.singleSubPrice * 1.8 : cached.singleSubPrice;
        }
      }
    }

    return {
      key: 'optimistic-' + variantId + '-' + Date.now(),
      variant_id: variantId,
      quantity: quantity,
      product_title: productTitle,
      image: productImage,
      url: `/products/${productHandle}`,
      final_price: pricePerUnit,
      final_line_price: pricePerUnit * quantity,
      original_price: pricePerUnit,
      original_line_price: pricePerUnit * quantity,
      selling_plan_allocation: sellingPlan ? { selling_plan: { id: sellingPlan } } : null,
      _optimistic: true
    };
  }

  function isOptimisticState(cartData) {
    return cartData && cartData.items && cartData.items.some(i => i._optimistic);
  }

  let checkoutOriginalText = null;
  let checkoutWatchdog = null;

  function lockCheckout(message) {
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', preventCheckout, true);
    }
    if (checkoutBtn) {
      if (checkoutOriginalText === null) {
        checkoutOriginalText = checkoutBtn.innerHTML;
      }
      checkoutBtn.style.opacity = '0.5';
      checkoutBtn.style.pointerEvents = 'none';
      if (message) {
        checkoutBtn.innerHTML = '<span style="font-size:17.5px;font-weight:600;">' + message + '</span>';
      }
    }
    // Safety net: an in-app webview can suspend JS mid-request. With the fetch
    // timeouts, ops settle in <=12s; if a lock somehow outlives that, force-unlock
    // and resync so the Checkout button can never stay dead forever.
    if (checkoutWatchdog) clearTimeout(checkoutWatchdog);
    checkoutWatchdog = setTimeout(function () {
      console.error('[AM Cart] checkout lock watchdog fired — force unlocking');
      unlockCheckout();
      fetchCart().then(render).catch(function () {});
    }, 15000);
  }

  function unlockCheckout() {
    if (checkoutWatchdog) { clearTimeout(checkoutWatchdog); checkoutWatchdog = null; }
    if (checkoutForm) {
      checkoutForm.removeEventListener('submit', preventCheckout, true);
    }
    if (checkoutBtn) {
      checkoutBtn.style.opacity = '';
      checkoutBtn.style.pointerEvents = '';
      if (checkoutOriginalText !== null) {
        checkoutBtn.innerHTML = checkoutOriginalText;
        checkoutOriginalText = null;
      }
    }
  }

  function preventCheckout(e) {
    e.preventDefault();
    e.stopPropagation();
  }

async function healAndCheckout(e) {
    if (isUpdating || isOptimisticState(cart)) return;
    if (!cart || !cart.items) return;

    // Boosters can't check out without a DLB parent
    const hasDlb = cart.items.some(i => isSingleSub(i.variant_id) || isDoubleSub(i.variant_id) || isDlbOneTime(i.variant_id));
    const hasBooster = cart.items.some(i => isBooster(i.variant_id));
    if (hasBooster && !hasDlb) {
      e.preventDefault(); e.stopPropagation();
      const upd = {};
      for (const k of cart.items.filter(i => isBooster(i.variant_id)).map(i => i.key)) upd[k] = 0;
      try { await updateCartItems(upd); await render(await fetchCart()); } catch (err) {}
      return;
    }

    // Decide synchronously from the in-memory cart so preventDefault lands in time
    const planless = cart.items.filter(i => isSubscription(i.variant_id) && !i.selling_plan_allocation);
    const kitLines = cart.items.filter(i => isWelcomeKit(i.variant_id));
    const kitVariants = [...new Set(kitLines.map(i => i.variant_id))];
    const kitTotalQty = kitLines.reduce((s, i) => s + i.quantity, 0);
    const kitsBroken = kitVariants.length > 1 || kitTotalQty > 1;
    if (planless.length === 0 && !kitsBroken) return; // nothing to fix — let checkout proceed

    e.preventDefault();   // MUST be synchronous, before any await
    e.stopPropagation();

    // v8.6 SAFETY: fail-open, but never leave the cart worse than we found it.
    //   - planless sub: ADD the planned line FIRST, then remove the planless one, so an
    //     interruption keeps the item (worst case a dedupable duplicate), never loses it.
    //   - capped at 12s (> the 8s per-request timeout) so slow-but-alive connections finish.
    //   - on timeout/error go to /cart (true server state), NOT a half-healed /checkout.
    let healOk = false;
    const heal = (async () => {
      for (const line of planless) {
        const plan = await resolveMarketPlan(line);
        if (!plan) continue;
        const alreadyPlanned = cart.items.some(i =>
          i.variant_id === line.variant_id && i.selling_plan_allocation && i.key !== line.key);
        if (!alreadyPlanned) {
          await addToCartApi([{ id: line.variant_id, quantity: line.quantity, selling_plan: plan }]);
        }
        await updateCartItems({ [line.key]: 0 });
      }
      if (kitsBroken) {
        const latest = await fetchCart();
        const updates = {};
        for (const l of latest.items.filter(i => isWelcomeKit(i.variant_id))) updates[l.key] = 0;
        if (Object.keys(updates).length) await updateCartItems(updates);
        const want = computeDesiredGifts(latest.items.filter(i => !isGift(i.variant_id)));
        const toAdd = Object.entries(want).map(([vid, qty]) => ({ id: parseInt(vid), quantity: qty, properties: { '_gift': 'true' } }));
        if (toAdd.length) await addToCartApi(toAdd);
      }
      healOk = true;
    })();

    try {
      await Promise.race([
        heal,
        new Promise((_, reject) => setTimeout(() => reject(new Error('heal-timeout')), 12000))
      ]);
    } catch (err) {
      console.error('[AM Cart] Checkout heal failed/timed out:', err);
    }

    // Healed cleanly -> checkout. Otherwise -> /cart so Shopify renders the true
    // server state instead of a half-healed cart being checked out.
    window.location.href = healOk ? (ROOT + 'checkout') : (ROOT + 'cart');
  }

  function buildOptimisticGift(variantId) {
    let giftImage = CONFIG.fallbackImages.singleKit;
    if (variantId === CONFIG.kits.auEx.double || variantId === CONFIG.kits.ex.double || variantId === CONFIG.kits.nr.double) {
      giftImage = CONFIG.fallbackImages.doubleKit;
    } else if (variantId === CONFIG.shaker) {
      giftImage = CONFIG.fallbackImages.shaker;
    }

    const info = getGiftDisplayInfo(variantId);
    return {
      key: 'optimistic-gift-' + variantId + '-' + Date.now(),
      variant_id: variantId,
      quantity: 1,
      product_title: info.name,
      image: giftImage,
      url: '',
      final_price: 0,
      final_line_price: 0,
      original_price: 0,
      original_line_price: 0,
      _optimistic: true
    };
  }

/* =========================================
     YOU MAY ALSO LIKE — booster quick-add
     ========================================= */
  const boostersEl = $('#am-cart-boosters');
  const boostersTrack = $('#am-cart-boosters-track');
  let boosterData = null;
  let boosterCarouselBuilt = false;

  async function loadBoosterData() {
    if (boosterData) return boosterData;
    const results = await Promise.all(CONFIG.boosters.map(async (b) => {
      try {
        const p = await fetchWithTimeout(`${ROOT}products/${b.handle}.js`, { credentials: 'same-origin' }).then(r => r.json());
        const subV = p.variants.find(v => v.id === b.sub);
        const otpV = p.variants.find(v => v.id === b.otp);
        const plan = b.addonPlan;   // booster is sold only as an add-on subscription now
        const img = p.featured_image || (p.images && p.images[0]) || '';
        productPriceCache[b.handle] = {
          otpPrice: otpV ? otpV.price : null,
          singleSubPrice: subV ? subV.price : null
        };
        return {
          key: b.key, handle: b.handle, title: b.title,
          image: img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : '',
          otpVariant: b.otp, subVariant: b.sub,
          otpPrice: otpV ? otpV.price : null,
          subPrice: subV ? subV.price : null,
          plan: plan
        };
      } catch (e) { return null; }
    }));
    boosterData = results.filter(Boolean);
    return boosterData;
  }

  function boosterCardHtml(b) {
    const subActive = !!b.plan;   // always subscription

    const priceNow = subActive && b.subPrice != null ? b.subPrice : b.otpPrice;
    const modeLabel = subActive ? 'Subscription' : 'One-time';
    const priceLabel = priceNow != null ? formatMoney(priceNow) : '';

    const fallbackImg = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" fill="%23f0f0f0"><rect width="76" height="76"/></svg>');

    return `
      <div class="am-booster-card" data-key="${b.key}" data-sub-active="${subActive ? '1' : '0'}">
        <div class="am-booster-card__media">
          <img class="am-booster-card__img" src="${b.image || fallbackImg}" alt="${b.title}" loading="lazy" onerror="this.src='${fallbackImg}'"/>
          <button type="button" class="am-booster-card__info" data-role="info" aria-label="Learn more about ${b.title}">i</button>
          <div class="am-booster-card__popover" data-role="popover" hidden>
            <p class="am-booster-card__popover-title">${b.title}</p>
            <p class="am-booster-card__popover-body">Placeholder description for ${b.title}. Add the key ingredients, benefits, and dosing info here so shoppers can learn about this booster without leaving the cart.</p>
          </div>
        </div>
        <p class="am-booster-card__name">${b.title}</p>
        <span class="am-booster-card__mode-label">${modeLabel}</span>
        <button type="button" class="am-booster-card__add" data-role="add">
          <span class="am-booster-card__add-label">Add</span>
          <span class="am-booster-card__add-price">${priceLabel}</span>
        </button>
      </div>
    `;
  }

  async function buildBoosterCarousel() {
    if (!boostersEl || !boostersTrack) return;
    if (!isAuMarket()) return;        // AU-only product line

    const data = await loadBoosterData();
    if (!data.length) return;
    boosterCarouselBuilt = true;
    boostersTrack.innerHTML = data.map(boosterCardHtml).join('');
    updateBoosterArrows();
  }

  function wireBoosterCarousel() {
    if (!boostersTrack) return;

    boostersTrack.addEventListener('click', async (e) => {
      const card = e.target.closest('.am-booster-card');
      if (!card) return;
      const b = (boosterData || []).find(x => x.key === card.dataset.key);
      if (!b) return;

      const infoBtn = e.target.closest('[data-role="info"]');
      if (infoBtn) {
        e.stopPropagation();
        const pop = card.querySelector('[data-role="popover"]');
        const isPopOpen = !pop.hidden;
        boostersTrack.querySelectorAll('[data-role="popover"]').forEach(p => { p.hidden = true; });
        pop.hidden = isPopOpen;
        return;
      }

      const addBtn = e.target.closest('[data-role="add"]');
      if (addBtn) {
        const variantId = b.subVariant;   // always the -SUB variant
        const plan = b.plan;              // always the add-on plan
        const original = addBtn.innerHTML;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
        await quickAddBooster(variantId, plan);
        addBtn.disabled = false;
        addBtn.innerHTML = original;
      }
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.am-booster-card')) {
        boostersTrack.querySelectorAll('[data-role="popover"]').forEach(p => { p.hidden = true; });
      }
    });

    const prev = $('#am-cart-boosters-prev');
    const next = $('#am-cart-boosters-next');
    if (prev) prev.addEventListener('click', () => scrollBoosters(-1));
    if (next) next.addEventListener('click', () => scrollBoosters(1));
    boostersTrack.addEventListener('scroll', updateBoosterArrows, { passive: true });
  }

  function scrollBoosters(dir) {
    if (!boostersTrack) return;
    const card = boostersTrack.querySelector('.am-booster-card');
    const step = card ? (card.offsetWidth + 10) : 160;
    boostersTrack.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
  }

  function updateBoosterArrows() {
    const prev = $('#am-cart-boosters-prev');
    const next = $('#am-cart-boosters-next');
    if (!boostersTrack || !prev || !next) return;
    const maxScroll = boostersTrack.scrollWidth - boostersTrack.clientWidth - 2;
    prev.classList.toggle('is-hidden', boostersTrack.scrollLeft <= 2);
    next.classList.toggle('is-hidden', boostersTrack.scrollLeft >= maxScroll);
  }

  async function quickAddBooster(variantId, sellingPlan) {
    if (isUpdating) return;
    if (!isAuMarket()) { console.warn('[AM Cart] boosters are AU-only'); return; }
    if (!cartHasDlb()) {
      flashBoosterBlocked();
      return;
    }
    /* THE CAROUSEL IS A SECOND ADD PATH AND IT HAD NO CAP.
       addToCartApi() raises internalAddDepth, so the fetch interceptor
       deliberately ignores it - nothing downstream would have caught this. */
    if ((await capAddQuantity(variantId, 1)) <= 0) { flashCapReached(variantId); return; }
    /* THE 2-TUB RULE APPLIES HERE TOO (final review, 14 Oct 2026). A booster
       may only join a cart holding at most 2 tubs of Blend, one-time included -
       the same rule addRoutine and the booster page enforce. */
    {
      let tubs = 0;
      ((cart && cart.items) || []).forEach(i => {
        if (isDoubleSub(i.variant_id)) tubs += 2 * i.quantity;
        else if (isSingleSub(i.variant_id) || isDlbOneTime(i.variant_id)) tubs += i.quantity;
      });
      if (tubs > 2) {
        flashBoosterBlocked('Targeted support can be added to one Monthly or one Double Subscription of Daily Longevity Blend.');
        return;
      }
    }
    isUpdating = true;
    lockCheckout('Adding to cart...');
    try {
      const line = { id: variantId, quantity: 1 };
      if (sellingPlan) line.selling_plan = sellingPlan;
      await addToCartApi([line]);
      const fresh = await fetchCart();
      await render(fresh);
    } catch (err) {
      console.error('[AM Cart] Booster quick-add failed:', err);
      try { await render(await fetchCart()); } catch (e) {}
    } finally {
      isUpdating = false;
      unlockCheckout();
    }
  }

  function flashBoosterBlocked(text) {
    const head = boostersEl && boostersEl.querySelector('.am-cart__boosters-head');
    if (!head) return;
    let msg = head.querySelector('.am-cart__boosters-note');
    if (!msg) {
      msg = document.createElement('span');
      msg.className = 'am-cart__boosters-note';
      head.appendChild(msg);
    }
    msg.textContent = text || 'Add a Daily Longevity Blend first';
    msg.classList.add('is-visible');
    clearTimeout(msg._t);
    msg._t = setTimeout(() => msg.classList.remove('is-visible'), 2600);
  }

  /* =========================================
     CART OPERATIONS
     ========================================= */

/* ---------------------------------------------------------------------------
     THE QUANTITY CAPS ARE ENFORCED HERE, NOT ONLY IN THE DRAWER.
     getMaxQty() was consulted in exactly three places - the + button's disabled
     state, the cap notice, and canIncrease() - and ALL THREE are inside the
     drawer. Every add from a product page goes through this function instead,
     which had no cap logic whatsoever. So the drawer would say "maximum
     reached" while a customer kept pressing Add to cart on the PDP and walked
     a 10-tub order through to checkout. This is where it has to be caught,
     because this is the only path every add shares.
     ------------------------------------------------------------------------ */
  /* The clamp itself, with NO await inside it. Splitting this out is what lets
     addProductWithGift do "work out the room, then reserve it" as one
     uninterrupted step. */
  function capAddQuantitySync(variantId, wanted) {
    const max = getMaxQty(variantId);
    if (max >= 99) return wanted;                 // uncapped product, never touched
    const items = (cart && cart.items) || [];
    let current = 0;
    for (const i of items) if (i.variant_id === variantId) current += i.quantity;
    current += (inFlightAdds[variantId] || 0);    // adds not yet reflected in `cart`
    return Math.max(0, Math.min(wanted, max - current));
  }

  async function capAddQuantity(variantId, wanted) {
    if (!cart) {
      try { cart = await fetchCart(); } catch (e) { return wanted; }   // fail OPEN
    }
    return capAddQuantitySync(variantId, wanted);
  }

  /* The sentence the customer actually sees. renderCapNotice() describes the
     CART; this describes the thing they just tried to add, which is what they
     need when the drawer is already open and nothing on screen changes. */
  /* The Blend ceiling THAT APPLIES TO THE CART IN FRONT OF US, in tubs.
     Boosters drop it to two; otherwise it is the flat maxTotalSub. */
  function blendTubCap() {
    const items = (cart && cart.items) || [];
    return items.some(i => isBooster(i.variant_id)) ? 2 : CONFIG.maxTotalSub;
  }

  /* SAME SENTENCE, SAME NUMBER, AS THE CART NOTICE (renderCapNotice /
     amCapNoticeText). This used to quote CONFIG.maxTotalSub flat, so the PDP
     said "4 tubs" while the drawer - which reports what the cart is actually
     capped at - said "3". Deriving the figure from the cart keeps the two in
     step, including the booster case where the real ceiling is two tubs. */
  function capReason(variantId) {
    if (isBooster(variantId)) return capSentence(true, false);
    if (isSingleSub(variantId) || isDoubleSub(variantId)) return capSentence(false, true);
    return capSentence(true, true);
  }

  /* THE NOTICE SURVIVES RE-RENDERS (fix review 23 Oct 2026). flashCapReached is
     followed by openDrawer()/refreshCart(), and render() rewrites
     #am-cart-sub-items, so the notice was wiped within one fetch. render() now
     puts it back for the 4 seconds it is meant to show. */
  let pendingFlash = null;
  function showPendingFlash() {
    if (!pendingFlash || Date.now() >= pendingFlash.until) { pendingFlash = null; return; }
    try {
      const host = document.querySelector('#am-cart-sub-items') || document.querySelector('#am-cart-body');
      if (!host) return;
      let el = document.getElementById('am-cart-cap-flash');
      if (!el) {
        el = document.createElement('div');
        el.id = 'am-cart-cap-flash';
        el.className = 'am-cart__max-msg is-visible';
        el.setAttribute('role', 'status');
        host.insertAdjacentElement('afterbegin', el);
      }
      el.textContent = pendingFlash.msg;
      clearTimeout(el._t);
      el._t = setTimeout(() => { if (el && el.parentNode) el.parentNode.removeChild(el); }, Math.max(0, pendingFlash.until - Date.now()));
    } catch (e) {}
  }
  function flashCapReached(variantId) {
    const msg = capReason(variantId);
    pendingFlash = { msg, until: Date.now() + 4000 };
    try { console.warn('[AM Cart] add refused:', msg, variantId); } catch (e) {}
    /* Put a real, timed message on screen. The previous version computed the
       notice into an unused variable and relied on the drawer re-rendering,
       so when the drawer was ALREADY open absolutely nothing changed and the
       add simply vanished. */
    try {
      const host = document.querySelector('#am-cart-sub-items') || document.querySelector('#am-cart-body');
      if (host) {
        let el = document.getElementById('am-cart-cap-flash');
        if (!el) {
          el = document.createElement('div');
          el.id = 'am-cart-cap-flash';
          el.className = 'am-cart__max-msg is-visible';
          el.setAttribute('role', 'status');
          host.insertAdjacentElement('afterbegin', el);
        }
        el.textContent = msg;
        clearTimeout(el._t);
        el._t = setTimeout(() => { if (el && el.parentNode) el.parentNode.removeChild(el); }, 4000);
      }
    } catch (e) {}
    if (!isOpen) openDrawer(); else refreshCart();
  }

  /* Adds in flight, per variant, so a second tap cannot clamp against a cart
     that does not yet include the first add. The optimistic window is ~1.8s,
     which is ample time for a double tap. */
  const inFlightAdds = {};

  async function addProductWithGift(variantId, quantity, sellingPlan, properties) {
    /* CLAIM THE RESOLVER FOR THIS ADD - synchronously, before the first await.
       Every settle site below used to read the module-level drawerReadyResolve
       slot. Two overlapping adds SHARE that slot, so the second tap's resolver
       was settled by the FIRST add's outcome and the first tap's promise was
       orphaned for good: the PDP button sat in its loading state until the page
       was reloaded. Owning it locally means each add settles its own promise,
       exactly once, and the outer finally guarantees it never settles zero
       times. */
    const myResolve = drawerReadyResolve;
    drawerReadyResolve = null;
    let addSettled = false;
    const settleAdd = (outcome) => {
      if (addSettled || !myResolve) return;
      addSettled = true;
      try { myResolve(outcome); } catch (e) { console.error('[AM Cart] settle failed:', e); }
    };

    /* Clamp BEFORE anything else. A partial add still goes through (asking for
       3 when there is room for 1 adds 1); a full refusal opens the drawer so
       the cap notice can say what the limit is.
       SETTLE THE FAKED FETCH on refusal: without it the theme's product form
       waits the full 8s fallback with the button stuck in its loading state. */
    const refuse = () => {
      flashCapReached(variantId);
      settleAdd({ ok: false, reason: capReason(variantId) });
    };

    /* First pass. This one may have to fetch the cart, so it awaits. */
    if ((await capAddQuantity(variantId, quantity)) <= 0) { refuse(); return; }

    /* SECOND PASS, THEN RESERVE — WITH NO await BETWEEN THE TWO.
       The reservation used to sit after the await above, leaving a microtask
       gap: two taps both measured the cart BEFORE either had reserved, both
       were granted 1, and a cart capped at 3 reached 4. Running the sync clamp
       and the reservation back to back closes that window — by the time the
       second tap measures, the first tap's units are already counted in
       inFlightAdds. The finally block always releases them. */
    const granted = capAddQuantitySync(variantId, quantity);
    if (granted <= 0) { refuse(); return; }
    quantity = granted;
    inFlightAdds[variantId] = (inFlightAdds[variantId] || 0) + quantity;
    try {

    if (isSubscription(variantId) && !sellingPlan) {
      sellingPlan = await getSellingPlanForVariant(variantId);
    }
    const items = [];
    const productItem = { id: variantId, quantity: quantity };
    if (sellingPlan) productItem.selling_plan = sellingPlan;
    if (properties && Object.keys(properties).length > 0) productItem.properties = properties;
    items.push(productItem);

    if (isSingleSub(variantId) || isDoubleSub(variantId)) {
      const giftId = getGiftForVariant(variantId);
      if (giftId) items.push({ id: giftId, quantity: 1, properties: { '_gift': 'true' } });
    }

    const startingCart = cart || getCachedCart() || { items: [], item_count: 0, total_price: 0 };
    const optimisticCart = JSON.parse(JSON.stringify(startingCart));

    optimisticCart.items = (optimisticCart.items || []).filter(i => !isGift(i.variant_id));
    optimisticCart.items.push(buildOptimisticItem(variantId, quantity, sellingPlan));

    const desiredGifts = computeDesiredGifts(optimisticCart.items);
    for (const vid of Object.keys(desiredGifts).map(Number)) {
      optimisticCart.items.push(buildOptimisticGift(vid));
    }

    optimisticCart.item_count = optimisticCart.items
      .filter(i => !isGift(i.variant_id))
      .reduce((sum, i) => sum + i.quantity, 0);
    optimisticCart.total_price = optimisticCart.items.reduce((sum, i) => sum + (i.final_line_price || 0), 0);

    const addPromise = (async () => {
      await addToCartApi(items);
      return await fetchCart();
    })();

    await new Promise(resolve => setTimeout(resolve, 1800));

    if (!isOpen) {
      isOpen = true;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      body.classList.add('am-cart-open');
    }
    render(optimisticCart);

    try {
      let cartData = await addPromise;
      /* A booster added from anywhere other than the results page - a PDP, the
         drawer's own rail, a link - lands here. addProductWithGift opens the
         drawer by hand rather than calling openDrawer(), so refreshCart() never
         runs and the orphan guard never fired. That is how a booster was
         reaching the cart on its own. */
      const dlbFix = await ensureDlbForBoosters(cartData);
      if (dlbFix) cartData = dlbFix;
      await render(cartData);

      settleAdd({ ok: true, quantity: quantity });   // the clamped figure, not the request

      const desired = computeDesiredGifts(cartData.items.filter(i => !isGift(i.variant_id)));
      const currentGifts = {};
      for (const item of cartData.items) {
        if (isGift(item.variant_id)) {
          currentGifts[item.variant_id] = (currentGifts[item.variant_id] || 0) + item.quantity;
        }
      }
      let giftsCorrect = true;
      for (const [vid, qty] of Object.entries(desired)) {
        if ((currentGifts[parseInt(vid)] || 0) !== qty) { giftsCorrect = false; break; }
      }
      for (const vid of Object.keys(currentGifts)) {
        if (!desired[vid]) { giftsCorrect = false; break; }
      }
      if (!regionSyncing && !giftsCorrect) {
        const giftUpdates = {};
        for (const item of cartData.items) {
          if (isGift(item.variant_id)) giftUpdates[item.key] = 0;
        }
        if (Object.keys(giftUpdates).length > 0) await updateCartItems(giftUpdates);
        const toAdd = [];
        for (const [vid, qty] of Object.entries(desired)) {
          toAdd.push({ id: parseInt(vid), quantity: qty, properties: { '_gift': 'true' } });
        }
        if (toAdd.length > 0) await addToCartApi(toAdd);
        const fixedCart = await fetchCart();
        await render(fixedCart);
      }
    } catch (err) {
      console.error('[AM Cart] Add failed:', err);
      try {
        const recoveryCart = await fetchCart();
        await render(recoveryCart);
      } catch (e) {
        // Recovery also failed (dead network) — don't leave checkout locked.
        unlockCheckout();
      }
      settleAdd({ ok: true, quantity: quantity });
    }

    } finally {
      inFlightAdds[variantId] = Math.max(0, (inFlightAdds[variantId] || 0) - quantity);
      if (!inFlightAdds[variantId]) delete inFlightAdds[variantId];
      /* LAST RESORT. If any path above returned or threw without settling, the
         button unsticks now instead of after the 8s fallback. ok:true matches
         the catch block: never show the shopper an error for a cart that may
         well have taken the item. */
      settleAdd({ ok: true, quantity: quantity });
    }
  }

  const pendingUpdates = {};
  let updateScheduled = false;
  let realGiftKeys = [];

async function updateQuantity(key, variantId, newQty) {
    if (!cart) return;
    const safeNewQty = newQty <= 0 ? 0 : newQty;

    const lineItem = cart.items.find(i => i.key === key);
    if (!lineItem) return;
    const pricePerUnit = lineItem.final_price;

    const currentRealGifts = cart.items.filter(i => isGift(i.variant_id) && !i.key.startsWith('temp-gift-') && !i.key.startsWith('optimistic-'));
    if (currentRealGifts.length > 0) realGiftKeys = currentRealGifts.map(i => i.key);

    let cascadeBoosterKeys = [];
    if (safeNewQty === 0) {
      cart.items = cart.items.filter(i => i.key !== key);
      const dlbLeft = cart.items.some(i => isSingleSub(i.variant_id) || isDoubleSub(i.variant_id) || isDlbOneTime(i.variant_id));
      if (!dlbLeft && !isBooster(variantId)) {
        cascadeBoosterKeys = cart.items.filter(i => isBooster(i.variant_id)).map(i => i.key);
        cart.items = cart.items.filter(i => !isBooster(i.variant_id));
      }
    } else {
      lineItem.quantity = safeNewQty;
      lineItem.final_line_price = pricePerUnit * safeNewQty;
      lineItem.original_line_price = lineItem.original_price * safeNewQty;
    }

    /* THE "booster may never outnumber the Blend" RULE LIVED HERE TOO.
       It ran AFTER the new quantity had been written, silently rolling a
       booster back to the Blend quantity - so the drawer showed 2 for an
       instant, then snapped to 1, and the server was told to stay at 1. That
       is the "it looks like it works but does nothing" report.
       Two boosters ride on one Blend. The only booster ceiling is
       MAX_BOOSTERS, and getMaxQty() owns it. Do not reintroduce a second one
       here: a rule in this function cannot be seen by the + button or the cap
       notice, so it can only ever present as a broken control. */

    const desiredGifts = computeDesiredGifts(cart.items);
    cart.items = cart.items.filter(i => !isGift(i.variant_id));
    for (const [vid, qty] of Object.entries(desiredGifts)) {
      cart.items.push({ key: 'temp-gift-' + vid, variant_id: parseInt(vid), quantity: qty, final_price: 0, final_line_price: 0, original_price: 0, original_line_price: 0, product_title: 'Free Gift', image: null, url: '' });
    }

    cart.item_count = cart.items.reduce((sum, i) => sum + (isGift(i.variant_id) ? 0 : i.quantity), 0);
    cart.total_price = cart.items.reduce((sum, i) => sum + i.final_line_price, 0);

    setCachedCart(cart);
    await render(cart);

    pendingUpdates[key] = safeNewQty;
    for (const bk of cascadeBoosterKeys) pendingUpdates[bk] = 0;
    lockCheckout('Updating cart...');
    scheduleServerSync();
  }

  let syncDebounceTimer = null;
  function scheduleServerSync() {
    if (syncDebounceTimer) clearTimeout(syncDebounceTimer);
    syncDebounceTimer = setTimeout(executeServerSync, 300);
  }

  async function executeServerSync() {
    if (updateScheduled) return;
    updateScheduled = true;

    try {
      const updates = { ...pendingUpdates };
      Object.keys(pendingUpdates).forEach(k => delete pendingUpdates[k]);

      const serverUpdates = { ...updates };
      for (const giftKey of realGiftKeys) {
        if (!(giftKey in serverUpdates)) {
          serverUpdates[giftKey] = 0;
        }
      }
      realGiftKeys = [];

      const updatedCart = await updateCartItems(serverUpdates);

      const nonGiftItems = updatedCart.items.filter(i => !isGift(i.variant_id) && isProduct(i.variant_id));
      const desiredGifts = computeDesiredGifts(nonGiftItems);
      const toAdd = [];
      for (const [vid, qty] of Object.entries(desiredGifts)) {
        toAdd.push({ id: parseInt(vid), quantity: qty, properties: { '_gift': 'true' } });
      }

      let finalCart;
      if (toAdd.length > 0) {
        await addToCartApi(toAdd);
        finalCart = await fetchCart();
      } else {
        finalCart = updatedCart;
        setCachedCart(finalCart);
      }

      /* The other way to orphan a booster: have both in the cart and delete the
         Blend. Quantity changes settle here, so the guard has to run here too. */
      if (!IS_CART_PAGE) {
        const dlbFix = await ensureDlbForBoosters(finalCart);
        if (dlbFix) finalCart = dlbFix;
      }

      if (finalCart.item_count !== cart.item_count || finalCart.total_price !== cart.total_price) {
        await render(finalCart);
      } else {
        cart = finalCart;
      }
    } catch (err) {
      console.error('[AM Cart] Error syncing to server:', err);
      try {
        const recoveryCart = await fetchCart();
        await render(recoveryCart);
      } catch (e) {}
    } finally {
      updateScheduled = false;
      if (Object.keys(pendingUpdates).length > 0) {
        scheduleServerSync();
      } else {
        unlockCheckout();
      }
    }
  }

  async function handleClearAll() {
    if (isUpdating) return;
    isUpdating = true;
    try {
      const clearedCart = await clearCartApi();
      try { sessionStorage.removeItem(CACHE_KEY); } catch (e) {}
      setCachedCart(clearedCart);
      await render(clearedCart);
    } catch (err) {
      console.error('[AM Cart] Error clearing cart:', err);
    } finally {
      isUpdating = false;
    }
  }

function canIncrease(variantId) {
    if (!cart) return false;
    const productItems = cart.items.filter(i => !isGift(i.variant_id));
    const lineItem = productItems.find(i => i.variant_id === variantId);
    const currentQty = lineItem ? lineItem.quantity : 0;
    /* EVERY quantity rule lives in getMaxQty(). Do not add one here - the
       disabled state and the cap notice both read getMaxQty(), so a rule that
       exists only in this function produces a live button that does nothing
       and a notice that explains nothing. */
    return currentQty < getMaxQty(variantId);
  }

  /* =========================================
     OPEN / CLOSE
     ========================================= */

  /* NEUTRAL LOADER - NO SECTION HEADINGS, NO FOOTER.
     This used to borrow the subscription section to hold its message, so an
     empty cart flashed "SUBSCRIPTION / Every 30 days" plus the subtotal footer
     before render() swapped in "Your cart is empty". While loading we do not
     know what the cart holds, so show nothing that assumes it. render() hides
     the loader again. */
  function showDrawerLoading(message) {
    if (!itemsEl) return;
    if (emptyEl) emptyEl.style.display = 'none';
    itemsEl.style.display = '';
    if (footerEl) footerEl.style.display = 'none';
    if (subSection) subSection.style.display = 'none';
    if (otpSection) otpSection.style.display = 'none';
    if (giftsSection) giftsSection.style.display = 'none';
    if (giftsDivider) giftsDivider.style.display = 'none';
    if (subItems) subItems.innerHTML = '';
    if (otpItems) otpItems.innerHTML = '';
    if (giftItems) giftItems.innerHTML = '';
    let loader = document.getElementById('am-cart-loading');
    if (!loader) {
      loader = document.createElement('div');
      loader.id = 'am-cart-loading';
      loader.setAttribute('role', 'status');
      loader.style.cssText = 'padding:48px 0;text-align:center;color:#9079FC;font-size:14px;';
      itemsEl.insertBefore(loader, itemsEl.firstChild);
    }
    loader.textContent = message || 'Loading your cart…';
    loader.style.display = '';
  }

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;
    const scrollY = window.scrollY;
    body.style.setProperty('--am-scroll-y', `-${scrollY}px`);
    body.dataset.scrollY = scrollY;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    body.classList.add('am-cart-open');

    const cached = getCachedCart();
    if (cached && cached.items && cached.items.length > 0) {
      render(cached);
    } else {
      showDrawerLoading();
    }
    refreshCart();
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    body.classList.remove('am-cart-open');
    const scrollY = parseInt(body.dataset.scrollY || '0');
    body.style.removeProperty('--am-scroll-y');
    delete body.dataset.scrollY;
    window.scrollTo(0, scrollY);
    if (cart) updateCartCount(cart.item_count);
  }

  async function refreshCart() {
    try {
      let cartData = await fetchCart();

      // On /cart, main-cart.liquid owns reconciliation — display only, no load-time writes.
      if (IS_CART_PAGE) {
        await render(cartData);
        return;
      }

      // Region-sync goes through fetchWithTimeout and can REJECT at 8s. If it does,
      // fall back to the true server state and clear any loading spinner.
      try {
        const regionSynced = await syncCartToMarket(cartData);
        if (regionSynced) cartData = regionSynced;
      } catch (e) {
        await render(cartData);
      }
      const dlbFixed = await ensureDlbForBoosters(cartData);   // orphaned booster → add the Blend
      if (dlbFixed) cartData = dlbFixed;
      await render(cartData);

      // Only reconcile gifts if a region-sync isn't already handling them.
      if (!regionSyncing) {
        const desired = computeDesiredGifts(cartData.items.filter(i => !isGift(i.variant_id)));
        const currentGifts = {};
        for (const item of cartData.items) {
          if (isGift(item.variant_id)) {
            currentGifts[item.variant_id] = (currentGifts[item.variant_id] || 0) + item.quantity;
          }
        }
        let giftsCorrect = true;
        for (const [vid, qty] of Object.entries(desired)) {
          if ((currentGifts[parseInt(vid)] || 0) !== qty) { giftsCorrect = false; break; }
        }
        for (const vid of Object.keys(currentGifts)) {
          if (!desired[vid]) { giftsCorrect = false; break; }
        }

        if (!giftsCorrect) {
          const giftResult = await syncGifts(cartData);
          if (giftResult) await render(giftResult);
        }
      }
    } catch (err) {
      console.error('[AM Cart] Error refreshing cart:', err);
      /* NEVER STRAND HER ON THE LOADER (review, 14 Oct 2026). If the cart could
         not be read while the neutral loader is up, say so and bring the
         footer back, so the Checkout button is there as it was before the
         loader existed. */
      try {
        const ld = document.getElementById('am-cart-loading');
        if (ld && ld.style.display !== 'none') {
          ld.textContent = "We couldn’t load your cart just now. Please refresh the page.";
          if (footerEl) footerEl.style.display = '';
        }
      } catch (_) {}
    }
  }

  /* =========================================
     EVENT LISTENERS & INTERCEPTION
     ========================================= */

  function init() {
    // If the drawer markup isn't on this template, don't throw — just no-op.
    if (!drawer || !overlay || !closeBtn || !continueBtn || !clearBtn || !upsellSubBtn) {
      console.warn('[AM Cart] drawer markup not found — skipping init on this template');
      return;
    }
    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    continueBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });

    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let isSwiping = false;

    drawer.addEventListener('touchstart', (e) => {
      if (!isOpen) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchCurrentX = touchStartX;
      isSwiping = false;
    }, { passive: true });

    drawer.addEventListener('touchmove', (e) => {
      if (!isOpen) return;
      touchCurrentX = e.touches[0].clientX;
      const deltaX = touchCurrentX - touchStartX;
      const deltaY = Math.abs(e.touches[0].clientY - touchStartY);

      if (!isSwiping && deltaX > 10 && deltaX > deltaY) {
        isSwiping = true;
      }

      if (isSwiping && deltaX > 0) {
        drawer.style.transform = `translateX(${deltaX}px)`;
        drawer.style.transition = 'none';
      }
    }, { passive: true });

    drawer.addEventListener('touchend', () => {
      if (!isSwiping) return;
      const deltaX = touchCurrentX - touchStartX;
      drawer.style.transition = '';
      drawer.style.transform = '';

      if (deltaX > 80) {
        closeDrawer();
      }
      isSwiping = false;
    });

    clearBtn.addEventListener('click', handleClearAll);
    upsellSubBtn.addEventListener('click', handleSwitchToSub);
    if (checkoutForm) checkoutForm.addEventListener('submit', healAndCheckout, true);
    wireBoosterCarousel();

    /* PRODUCT LINKS WIN.
       The drawer sits under a document-level capture listener that hijacks cart
       links, and the theme has its own delegated handlers. A plain <a> was
       being swallowed before the browser ever saw it. Claim the click first, in
       the capture phase, and navigate explicitly. */
    document.getElementById('am-cart-body').addEventListener('click', (e) => {
      const link = e.target.closest('a[data-am-link]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href || href === '#') return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) window.open(href, '_blank');
      else window.location.href = href;
    }, true);

    document.getElementById('am-cart-body').addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;
      const action = btn.dataset.action;
      const key = btn.dataset.key;
      const variantId = parseInt(btn.dataset.variantId);
      const item = cart.items.find(i => i.key === key);
      if (!item) return;

      if (action === 'remove') updateQuantity(key, variantId, 0);
      else if (action === 'decrease') updateQuantity(key, variantId, item.quantity - 1);
      else if (action === 'increase' && canIncrease(variantId)) {
        updateQuantity(key, variantId, item.quantity + 1);
      }
    });

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest(
        '.js-cart-trigger, [aria-controls="cart-drawer"], a[href="/cart"], a[href$="/cart"]'
      );
      if (trigger) {
        if (trigger.hasAttribute('data-am-link')) return;   // a cart line's product link
        if (trigger.closest('form[action="/cart"]')) return;
        if (trigger.closest('#am-cart-checkout-form')) return;
        if (trigger.textContent.trim().toLowerCase().includes('view cart')) return;
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
      }
    }, true);

    stripBoosterQuickAdd();

    interceptAddToCart();

    fetchCart().then(async cartData => {
      // On /cart, main-cart.liquid owns reconciliation — skip the load-time region write.
      if (!IS_CART_PAGE) {
        try {
          const regionSynced = await syncCartToMarket(cartData);
          if (regionSynced) cartData = regionSynced;
        } catch (e) {}   // region-sync can reject at the 8s timeout — keep true server state
      }
      /* Someone can arrive with an orphaned booster already in the cart - added
         in an earlier session, or on a page where the drawer never opened. Fix
         it on load rather than waiting for them to open the drawer. Skipped on
         /cart, where main-cart.liquid owns reconciliation and two writers fight. */
      if (!IS_CART_PAGE) {
        try { const f = await ensureDlbForBoosters(cartData); if (f) cartData = f; } catch (e) {}
      }
      cart = cartData;
      updateCartCount(cartData.item_count);
      const firstProduct = cartData.items.find(i => isProduct(i.variant_id));
      if (firstProduct) fetchProductPrices(firstProduct).catch(() => {});
    }).catch(() => {});

    /* WARM THE PRICE CACHE FROM THE PRODUCT PAGE WE ARE STANDING ON.
       THIS USED TO POISON IT. The scan matched variants against CONFIG.oneTime
       and CONFIG.singleSub, which hold DLB ids ONLY. On a booster PDP nothing
       matched, so it wrote { otpPrice: null, singleSubPrice: null } under the
       booster's handle - and because fetchProductPrices() returns early on any
       cached entry, the booster could never price itself again that session.
       That is why the Blend showed "Saving 20%" in the cart and the booster,
       added from its own page, showed nothing.
       Use the same predicates as fetchProductPrices, and never let a null
       result overwrite a populated one. */
    if (window.location.pathname.includes('/products/')) {
      const handle = window.location.pathname.match(/\/products\/([^/?]+)/);
      if (handle) {
        fetchWithTimeout(`${ROOT}products/${handle[1]}.js`).then(r => r.json()).then(product => {
          let otpPrice = null, singleSubPrice = null;
          for (const v of product.variants) {
            if (isOneTime(v.id)) otpPrice = v.price;
            if (isSubscription(v.id) && !isDoubleSub(v.id)) singleSubPrice = v.price;
          }
          if (otpPrice == null && singleSubPrice == null) return;   // learnt nothing - do not cache it
          const prev = productPriceCache[handle[1]];
          productPriceCache[handle[1]] = {
            otpPrice: otpPrice != null ? otpPrice : (prev ? prev.otpPrice : null),
            singleSubPrice: singleSubPrice != null ? singleSubPrice : (prev ? prev.singleSubPrice : null)
          };
        }).catch(() => {});
      }
    }
  }

  function interceptAddToCart() {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');

      if (url.includes('/cart/add') && internalAddDepth === 0) {
        const options = args[1] || {};
        let bodyData = null;

        try {
          if (options.body) {
            if (typeof options.body === 'string') {
              bodyData = JSON.parse(options.body);
            } else if (options.body instanceof FormData) {
              bodyData = { id: options.body.get('id'), quantity: options.body.get('quantity') };
              const sp = options.body.get('selling_plan');
              if (sp) bodyData.selling_plan = sp;
            }
          }
        } catch (e) {}

        if (bodyData) {
          const variantId = parseInt(bodyData.id || bodyData.items?.[0]?.id);
          const quantity = parseInt(bodyData.quantity || bodyData.items?.[0]?.quantity || 1);
          const sellingPlan = bodyData.selling_plan || bodyData.items?.[0]?.selling_plan || null;
          const properties = bodyData.properties || bodyData.items?.[0]?.properties || {};

          /* QUICK ADD MUST NOT SELL A BOOSTER ON ITS OWN.
             The collection card's "+ Quick add" posts a bare variant to
             /cart/add. For a booster that is wrong twice over: boosters are
             add-on only, and a booster alone has no Blend to attach to. Worse,
             this interceptor returns a FAKE 200, so the theme popped its own
             "added" toast while nothing reached the cart - which is exactly the
             ghost add seen on the boosters collection page.
             Send them to the booster's page, where the picker builds a bundle
             the cart rules accept. */
          if (variantId && !isNaN(variantId) && isBooster(variantId) && !properties._am_bundle) {
            const b = BOOSTER_BY_VARIANT[variantId];
            console.warn('[AM Cart] booster quick-add blocked — boosters are add-on only. Sending to the product page.');
            if (b && b.handle) window.location.href = ROOT + 'products/' + b.handle;
            return Promise.resolve(new Response(JSON.stringify({
              status: 422, message: 'Add-on only',
              description: 'Targeted supports are added alongside the Daily Longevity Blend.'
            }), { status: 422, headers: { 'Content-Type': 'application/json' } }));
          }

          if (variantId && !isNaN(variantId)) {
            /* EACH ADD OWNS ITS OWN RESOLVER.
               This used to assign an anonymous function to the shared
               drawerReadyResolve slot, and the 8s fallback then checked THE
               SLOT rather than its own resolver. Two taps in a row therefore
               overwrote the first resolver, the first timer resolved the
               SECOND promise, and the first fetch never settled at all - the
               theme's Add-to-cart button stayed disabled until a page reload.
               `mine` is captured in this closure, so no later add can orphan
               it, and the timer only clears the slot if it is still ours. */
            return new Promise(resolve => {
              let settled = false;
              const mine = (outcome) => {
                if (settled) return;
                settled = true;
                const ok = !outcome || outcome.ok !== false;
                const qty = (outcome && outcome.quantity != null) ? outcome.quantity : quantity;
                const body = ok
                  ? { items: [{ id: variantId, quantity: qty, title: 'Product', variant_id: variantId }] }
                  : { status: 422, message: 'Cart limit reached',
                      description: (outcome && outcome.reason) || 'This order is already at its maximum.' };
                resolve(new Response(JSON.stringify(body), {
                  status: ok ? 200 : 422,
                  headers: { 'Content-Type': 'application/json' }
                }));
              };
              /* ORDER MATTERS. addProductWithGift claims this slot in its own
                 synchronous prologue, so the slot has to hold OUR resolver
                 before the add starts. Calling the add first - as this did -
                 left it claiming the previous add's resolver or nothing at
                 all, and every single PDP add then waited out the full 8s
                 fallback with the button stuck. */
              drawerReadyResolve = mine;
              setTimeout(() => {
                if (drawerReadyResolve === mine) drawerReadyResolve = null;
                mine();                       // always settles, even if superseded
              }, 8000);
              /* Not awaited: the fake Response is resolved by `mine`. A throw
                 here would otherwise be an unhandled rejection, so settle. */
              addProductWithGift(variantId, quantity, sellingPlan, properties)
                .catch(err => {
                  console.error('[AM Cart] Add threw:', err);
                  if (drawerReadyResolve === mine) drawerReadyResolve = null;
                  mine();
                });
            });
          }
        }
      }

      if (url.includes('sections=') && url.includes('cart')) {
        return Promise.resolve(new Response('{}', {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
      }

      return originalFetch.apply(this, args);
    };

    const nativeDrawer = document.querySelector('cart-drawer, #cart-drawer');
    if (nativeDrawer) {
      nativeDrawer.style.display = 'none';
      const obs = new MutationObserver(() => {
        if (nativeDrawer.hasAttribute('open') ||
            nativeDrawer.className.match(/is-open|is-visible|active/)) {
          nativeDrawer.removeAttribute('open');
          nativeDrawer.classList.remove('is-open', 'is-visible', 'active');
          nativeDrawer.style.display = 'none';
        }
      });
      obs.observe(nativeDrawer, { attributes: true });
    }
  }

  /* =========================================
     BOOT
     ========================================= */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
// PUBLIC: add a full quiz routine (DLB + booster) + free Welcome Kit — opens instantly.
async function addRoutine(lines) {
    if (!Array.isArray(lines) || !lines.length || isUpdating) return;
    isUpdating = true;
    try {
      /* CLAMP ACROSS THE WHOLE BATCH, NOT LINE BY LINE.
         Each call used to be measured against the same pre-batch cart, so a
         routine of [Sleep x2, Collagen x2] passed both lines and put FOUR
         booster units into a cart capped at two. `reserved` carries what this
         batch has already claimed.
         And a blocked ADD-ON must never drop the Blend: the batch continues
         with whatever fits, and only throws if nothing fits at all - the
         previous version returned early, which silently cancelled the whole
         routine AND reported success to the quiz page. */
      const items = [];
      const skipped = [];
      /* MEASURE EACH LINE AGAINST A PROJECTION OF THE CART AS IT WILL BE.
         A per-variant "reserved" counter only fixed the booster cap; it could
         not see maxTotalSub, where a Single and a Double consume the same
         budget ([Single x3, Double x1] still reached 5 servings against a cap
         of 4). Building the projected cart and letting getMaxQty read it means
         every rule - line caps, booster totals, servings - is enforced across
         the batch with no special cases. */
      const realCart = cart;
      /* BOOSTERS ARE MEASURED FIRST (adversarial review, 14 Oct 2026).
         The Blend's limit depends on whether a booster is in the cart (2 tubs
         with one, 4 without). Measured in the order given - Blend first - the
         Blend line saw a cart with no booster yet and got the Blend-only limit,
         so a Double in the cart + the booster page's Double option became
         Double x2 + 2 boosters. Measuring boosters first means the Blend line
         sees them; if the Blend is already at its limit only the booster is
         added, onto the Blend that is there. Lines are still SENT in the
         original order. A batch with no booster in it is measured exactly as
         before. */
      let blendOverBoosterCap = false;
      try {
        const projected = { items: ((realCart && realCart.items) || []).map(i => Object.assign({}, i)) };
        const order = lines.map((l, idx) => ({ l, idx }))
          .sort((a, b) => (isBooster(b.l.id) ? 1 : 0) - (isBooster(a.l.id) ? 1 : 0) || a.idx - b.idx);
        const rooms = new Array(lines.length).fill(0);
        for (const { l, idx } of order) {
          cart = projected;
          const room = await capAddQuantity(l.id, l.quantity);
          if (room <= 0) continue;
          rooms[idx] = room;
          const existing = projected.items.find(i => i.variant_id === l.id);
          if (existing) existing.quantity += room;
          else projected.items.push({ variant_id: l.id, quantity: room, key: 'projected-' + l.id });
        }
        lines.forEach((l, idx) => {
          if (rooms[idx] <= 0) { skipped.push(l.id); return; }
          items.push(rooms[idx] === l.quantity ? Object.assign({}, l) : Object.assign({}, l, { quantity: rooms[idx] }));
        });
        /* A booster may only join a cart whose Blend is within the 2-tub rule.
           If the cart already holds more (e.g. Single x4), adding the booster
           would make a combination the pricing and the shipper do not cover. */
        if (projected.items.some(i => isBooster(i.variant_id))) {
          let tubs = 0;
          projected.items.forEach(i => {
            if (isDoubleSub(i.variant_id)) tubs += 2 * i.quantity;
            else if (isSingleSub(i.variant_id)) tubs += i.quantity;
            else if (isDlbOneTime(i.variant_id)) tubs += i.quantity;   // one-time counts too (Maddie, 14 Oct)
          });
          if (tubs > 2) blendOverBoosterCap = true;
        }
      } finally {
        cart = realCart;                 // never leave the projection in place
      }
      if (blendOverBoosterCap) {
        const err = new Error('cart-cap-blend-over-booster-limit');
        err.capReached = true;
        err.shopifyMessage = 'Targeted support can be added to one Monthly or one Double Subscription of Daily Longevity Blend. Please change the Daily Longevity Blend in your cart first.';
        throw err;                                   // nothing is added
      }
      /* The Blend line being skipped while its booster goes in is the expected
         "add to the Blend you already have" case, not a refusal - no flash. */
      const blendOnlySkipped = skipped.length && items.some(l => isBooster(l.id))
        && skipped.every(id => isSingleSub(id) || isDoubleSub(id) || isDlbOneTime(id));
      if (!items.length) {
        /* No flash here: it opened the drawer over the page, against the rule
           below, and both callers (quiz, booster picker) show shopifyMessage. */
        const err = new Error('cart-cap-no-room');
        err.capReached = true;
        err.shopifyMessage = capReason(lines[0] && lines[0].id);
        throw err;                                   // the caller must be told
      }
      /* A REQUESTED BOOSTER WITH NO ROOM MUST NOT LEAVE ONLY THE BLEND (audit 23 Oct).
         Cart Single + Sleep + Metabolic, quiz routine [Single, Hormone]: Hormone
         was skipped at the 2-booster cap and a second Single went in on its own,
         reported as success. She asked for Hormone, not another $79/mo Blend.
         So if every requested booster was skipped, nothing is added and the
         caller is told why. */
      const askedBooster = lines.some(l => isBooster(l.id));
      if (askedBooster && !items.some(l => isBooster(l.id))) {
        const boosterId = (lines.find(l => isBooster(l.id)) || {}).id;
        const err = new Error('cart-cap-booster-no-room');
        err.capReached = true;
        err.shopifyMessage = capReason(boosterId);
        throw err;                                   // nothing is added
      }
      /* Flash AFTER the drawer re-renders: render() rewrites the area the
         notice sits in, so a flash before the add was wiped straight away. */
      const flashAfter = (skipped.length && !blendOnlySkipped) ? skipped[0] : null;
      const dlb = items.find(l => isSingleSub(l.id) || isDoubleSub(l.id));
      if (dlb) { const kitId = getGiftForVariant(dlb.id); if (kitId) items.push({ id: kitId, quantity: 1, properties: { '_gift': 'true' } }); }
      await addToCartApi(items);
      const fresh = await fetchCart();
      const fixed = await syncGifts(fresh);
      await render(fixed || fresh);
      if (flashAfter) flashCapReached(flashAfter);
    } catch (e) {
      console.error('[AM Cart] addRoutine failed:', e);
      try { await render(await fetchCart()); } catch (_) {}
      isUpdating = false;
      /* DO NOT OPEN THE DRAWER ON A FAILED ADD.
         It opened regardless, so a refused add presented as an empty cart
         drawer sliding out - which reads as "the button is broken" and hides
         the reason. Re-throw so the caller (the PDP picker) can say what
         happened where the customer is actually looking. */
      throw e;
    } finally { isUpdating = false; }
    if (!isOpen) openDrawer(); else refreshCart();
  }
  /* ---- READ-ONLY SURFACE FOR THE BOOSTER PDPs -------------------------------
     The bundle picker on a booster PDP needs to know how many booster units are
     already in the cart before it can decide which offers still fit. It knows
     only its OWN booster, so without this it would need a second copy of the
     booster id list - and a second copy is how the two drift apart.

     capacity() returns everything the picker needs in one read:
       boosterUnits  total booster quantity in the cart
       remaining     how many more may be added (MAX_BOOSTERS - boosterUnits)
       dlbLine       'single' | 'double' | 'onetime' | null - which Blend line
                     is present, so the picker can spot the Single/Double clash
     Nothing here writes to the cart. */
  function amCapacity(cartData) {
    const items = (cartData && cartData.items) || [];
    let boosterUnits = 0, dlbLine = null, dlbTubs = 0;
    for (const i of items) {
      if (isBooster(i.variant_id)) boosterUnits += i.quantity;
      else if (isSingleSub(i.variant_id)) { dlbLine = 'single'; dlbTubs += i.quantity; }
      else if (isDoubleSub(i.variant_id)) { dlbLine = 'double'; dlbTubs += 2 * i.quantity; }
      else if (isDlbOneTime(i.variant_id)) { if (!dlbLine) dlbLine = 'onetime'; dlbTubs += i.quantity; }
    }
    return {
      boosterUnits,
      remaining: Math.max(0, MAX_BOOSTERS - boosterUnits),
      max: MAX_BOOSTERS,
      dlbLine,
      /* Blend tubs in the cart, one-time included. Over 2, no booster may be
         added (addRoutine refuses it), so the picker can say so before the click. */
      dlbTubs,
      boosterIds: CONFIG.boosters.map(b => ({ key: b.key, title: b.title, sub: b.sub, otp: b.otp }))
    };
  }
  /* ---------------------------------------------------------------------------
     NO QUICK ADD ON BOOSTER CARDS.
     A booster cannot be bought on its own, so a collection card offering to add
     one straight to the cart is a dead end - it used to pop the theme's "added"
     toast while nothing reached the cart. The card itself stays: people want to
     read about the boosters, and the card still links through to the PDP where
     the picker builds a valid bundle.

     Done here rather than in the product-card snippet because this file already
     loads site-wide and already owns the booster id list. If the card snippet
     ever gains a proper gate, delete this.
     ------------------------------------------------------------------------ */
  function stripBoosterQuickAdd() {
    const handles = CONFIG.boosters.map(b => b.handle).filter(Boolean);
    const boosterIds = [];
    CONFIG.boosters.forEach(b => { boosterIds.push(String(b.sub), String(b.otp)); });
    if (!handles.length) return;

    function looksQuickAdd(el) {
      /* A link to the product is the CARD link, never a quick-add control -
         even though its textContent contains the button's "Quick add" when the
         button is nested inside it, which is how the mobile card is built. */
      const href = el.getAttribute && el.getAttribute('href');
      if (href && href.indexOf('/products/') >= 0) return false;
      const cls = (el.getAttribute('class') || '') + ' ' + el.tagName.toLowerCase();
      if (/quick-?add/i.test(cls) || el.hasAttribute('data-quick-add')) return true;
      /* Text alone only counts for something that does not WRAP the card link,
         or we would tear out the product image and its href with it. */
      if (el.querySelector && el.querySelector('a[href*="/products/"]')) return false;
      return /quick add/i.test((el.textContent || '').trim());
    }

    /* Which product does this control belong to? Climb until we find an
       ancestor whose product links all point at ONE handle - that is the card,
       whatever it is called. Stop as soon as two handles appear: that is the
       grid, and the control is not ours to judge. */
    function handleFor(el) {
      let node = el.parentElement;
      for (let depth = 0; node && depth < 10; depth++, node = node.parentElement) {
        const links = node.querySelectorAll('a[href*="/products/"]');
        if (!links.length) continue;
        const found = {};
        let n = 0;
        links.forEach(a => {
          const m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
          if (m && !found[m[1]]) { found[m[1]] = true; n++; }
        });
        if (n === 1) return Object.keys(found)[0];
        if (n > 1) return null;
      }
      return null;
    }

    /* A form carrying a booster variant id is proof, whatever the DOM shape. */
    function carriesBoosterId(el) {
      const scopes = [el];
      /* Shopify's quick-add is usually a <form> with a hidden id input and the
         button inside it, so the id sits on a SIBLING of the button, not within
         it. Check the enclosing form too. */
      const form = el.closest && el.closest('form, product-form, [class*="quick-add"]');
      if (form && form !== el) scopes.push(form);
      for (const scope of scopes) {
        const inputs = scope.querySelectorAll('input[name="id"], input[name="items[0][id]"], [data-variant-id]');
        for (const inp of inputs) {
          const v = inp.value || inp.getAttribute('data-variant-id');
          if (v && boosterIds.indexOf(String(v).trim()) >= 0) return true;
        }
      }
      return false;
    }

    function removeControl(el) {
      /* Take the wrapper, not just the button - closest() matches the element
         itself and the button's own class is often "quick-add__button". */
      let host = el, up = el.parentElement;
      while (up && /quick-?add/i.test(up.getAttribute('class') || '')) { host = up; up = up.parentElement; }
      /* If the control lives in a form that only exists to add this product,
         take the form - otherwise an empty form and its spacing survive. */
      const f = host.closest && host.closest('form, product-form');
      if (f && f !== host && !f.querySelector('a[href*="/products/"]')) host = f;
      if (!host || !host.parentNode) return false;
      if (host.querySelector && host.querySelector('a[href*="/products/"]')) return false;  // would take the card link
      host.remove();
      return true;
    }

    /* INVERTED: start from the controls, not the cards. The card markup differs
       between the desktop grid and the mobile grid, and a sweep that climbed
       from the product link found the desktop button but missed the mobile one. */
    function sweep() {
      let removed = 0;
      const controls = document.querySelectorAll(
        'button, a, quick-add-button, product-form, form, [data-quick-add], [class*="quick-add"]');
      Array.prototype.forEach.call(controls, el => {
        if (!el.parentNode) return;
        if (!looksQuickAdd(el)) return;
        const h = handleFor(el);
        const mine = (h && handles.indexOf(h) >= 0) || carriesBoosterId(el);
        if (!mine) return;
        if (removeControl(el)) removed++;
      });
      if (removed) console.log('[AM Cart] removed ' + removed + ' booster quick-add control(s) — boosters are add-on only');
      return removed;
    }

    let pending = null;
    function scheduleSweep() {
      if (pending) return;
      pending = setTimeout(() => { pending = null; sweep(); }, 80);
    }

    sweep();
    /* Grids paginate, filter and re-render over AJAX, and the mobile grid can
       mount after first paint - so re-sweep on any DOM change, on resize, and
       twice more shortly after load. */
    try {
      new MutationObserver(scheduleSweep).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    window.addEventListener('resize', scheduleSweep);
    setTimeout(sweep, 600);
    setTimeout(sweep, 2000);
  }

  window.AMCart = {
    open: openDrawer, close: closeDrawer, refresh: refreshCart, addRoutine,
    capacity: async function () {
      try { return amCapacity(await fetchCart()); }
      catch (e) { return null; }   // fail open: the picker must not block on a bad read
    },
    capacityFrom: amCapacity
  };
})();